import 'core-js/modules/es6.function.name.js';
import React, { useRef, useEffect, forwardRef, useState } from 'react';
import styled from 'styled-components';
import 'core-js/modules/es6.object.assign.js';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es7.array.includes.js';
import 'core-js/modules/es6.regexp.split.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import md from 'markdown-ast';
import 'core-js/modules/es6.array.find.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.regexp.replace.js';
import 'core-js/modules/es6.number.constructor.js';
import 'core-js/modules/es6.array.slice.js';
import cloneDeep from 'lodash/cloneDeep';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var fontWeight = {
  thin: 100,
  'extra-light': 200,
  light: 300,
  normal: 400,
  medium: 500,
  'semi-bold': 600,
  bold: 700,
  'extra-bold': 800,
  black: 900
};
var alignment = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  between: 'space-between',
  // not sure about these three
  evenly: 'space-evenly',
  around: 'space-around',
  normal: 'row',
  reverse: 'row-reverse'
};
var tone = {
  default: '#E8E8E8',
  info: '#E0F0FF',
  success: '#CDFEE1',
  attention: '#FFEF9D',
  warning: '#FFD6A4',
  critical: '#FEDAD9',
  plain: '#FFFFFF'
};
var text = {
  default: '#616161',
  info: '#00527C',
  success: '#0C5132',
  attention: '#4F4700',
  warning: '#5E4200',
  critical: '#8E1F0B',
  plain: '#616161'
};

var _templateObject$j;
var StyledSpinner = styled.span(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  height: 100%;\n  min-height: 20px;\n  min-width: 20px;\n  border: 2px solid ", ";\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n\n  @keyframes rotation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), function (prop) {
  return prop.color ? prop.color : '#000';
});
var Spinner = function Spinner(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement(StyledSpinner, {
    color: color
  });
};

var _templateObject$i, _templateObject2$5;
// styling the button component based on props
var StyledButton = styled.button(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n  font-family: ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  opacity: ", ";\n  white-space: ", ";\n  width: max-content;\n  background-color: ", ";\n\n  color: ", ";\n\n  cursor: ", ";\n\n  text-decoration: ", ";\n\n  & .icon-before {\n    display: inherit;\n    margin-right: ", "px;\n    margin-top: auto;\n    margin-bottom: auto;\n    svg {\n      width: ", "px;\n      height: ", "px;\n    }\n  }\n\n  & .icon-after {\n    display: inherit;\n    margin-left: ", "px;\n    margin-top: auto;\n    margin-bottom: auto;\n    svg {\n      width: ", "px;\n      height: ", "px;\n    }\n  }\n\n  //&.primary:hover {\n  //    background-color: #ffffff;\n  //    color: #121212;\n  //}\n  //&.secondary:hover {\n  //    background-color: #dedede;\n  //}\n  //&.plain:hover {\n  //    background-color: #dedede;\n  //}\n  //\n  // figure out the hover animations later\n"])), function (props) {
  return props.textAlign && alignment[props.textAlign];
}, function (props) {
  return props.fullWidth && 'width: 100%';
}, function (props) {
  return props.borderColor;
}, function (prop) {
  return prop.cornerRadius && prop.cornerRadius;
}, function (props) {
  return props.padding && props.padding;
}, function (props) {
  return props.fontFamily && props.fontFamily;
}, function (props) {
  return props.textSize && props.textSize;
}, function (props) {
  return props.fontWeight && fontWeight[props.fontWeight];
}, function (props) {
  return props.fontStyle && props.fontStyle;
}, function (props) {
  return props.disabled ? 0.5 : 1;
}, function (props) {
  return props.whitespace;
}, function (props) {
  return props.bgColor ? props.bgColor : props.kind === 'primary' ? '#121212' : 'transparent';
}, function (props) {
  return props.color ? props.color : props.kind === 'primary' ? '#ffffff' : '#121212';
}, function (props) {
  return props.disabled && 'not-allowed';
}, function (props) {
  return props.kind === 'underline' && 'underline';
}, function (props) {
  return props.iconSpacing && props.iconSpacing;
}, function (props) {
  return props.iconBeforeSize && props.iconBeforeSize;
}, function (props) {
  return props.iconBeforeSize && props.iconBeforeSize;
}, function (props) {
  return props.iconSpacing && props.iconSpacing;
}, function (props) {
  return props.iconAfterSize && props.iconAfterSize;
}, function (props) {
  return props.iconAfterSize && props.iconAfterSize;
});
var Button = function Button(_ref) {
  var id = _ref.id,
    _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'primary' : _ref$kind,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '14px 22px' : _ref$padding,
    _ref$cornerRadius = _ref.cornerRadius,
    cornerRadius = _ref$cornerRadius === void 0 ? '5px' : _ref$cornerRadius,
    bgColor = _ref.bgColor,
    color = _ref.color,
    textSize = _ref.textSize,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? 'inherit' : _ref$fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'medium' : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    _ref$iconBeforeSize = _ref.iconBeforeSize,
    iconBeforeSize = _ref$iconBeforeSize === void 0 ? 24 : _ref$iconBeforeSize,
    _ref$iconAfterSize = _ref.iconAfterSize,
    iconAfterSize = _ref$iconAfterSize === void 0 ? 24 : _ref$iconAfterSize,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === void 0 ? 10 : _ref$iconSpacing,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    children = _ref.children,
    onClick = _ref.onClick,
    loading = _ref.loading,
    disabled = _ref.disabled,
    borderColor = _ref.borderColor,
    _ref$whitespace = _ref.whitespace,
    whitespace = _ref$whitespace === void 0 ? 'normal' : _ref$whitespace,
    spinnerColor = _ref.spinnerColor;
  return /*#__PURE__*/React.createElement(StyledButton, {
    id: id,
    kind: kind,
    padding: padding,
    cornerRadius: cornerRadius,
    bgColor: bgColor,
    color: color,
    textSize: textSize,
    textAlign: textAlign,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    iconBefore: iconBefore,
    iconAfter: iconAfter,
    iconBeforeSize: iconBeforeSize,
    iconAfterSize: iconAfterSize,
    iconSpacing: iconSpacing,
    fullWidth: fullWidth,
    onClick: onClick,
    disabled: disabled,
    style: {
      fontFamily: fontFamily
    },
    borderColor: borderColor ? borderColor : kind === 'secondary' ? '#dedede' : 'transparent',
    whitespace: whitespace
  }, loading && (/*#__PURE__*/React.createElement(StyledSpinnerCon, null, /*#__PURE__*/React.createElement(Spinner, {
    color: spinnerColor
  }))), !loading && iconBefore && (/*#__PURE__*/React.createElement("span", {
    className: "icon-before"
  }, iconBefore)), !loading && children, !loading && iconAfter && /*#__PURE__*/React.createElement("span", {
    className: "icon-after"
  }, iconAfter));
};
var StyledSpinnerCon = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 4vw;\n"])));

var _templateObject$h;
var Block = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n  padding: ", ";\n  margin: ", ";\n  border: ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.textAlign && prop.textAlign;
}, function (prop) {
  return prop.width && prop.width;
}, function (prop) {
  return prop.height || 'inherit';
}, function (prop) {
  return prop.verticalAlign && alignment[prop.verticalAlign];
}, function (prop) {
  return prop.horizontalAlign && alignment[prop.horizontalAlign];
}, function (prop) {
  return prop.gap && prop.gap;
}, function (prop) {
  return prop.padding && prop.padding;
}, function (prop) {
  return prop.margin && prop.margin;
}, function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.cornerRadius && prop.cornerRadius;
}, function (prop) {
  return prop.color && prop.color;
}, function (prop) {
  return prop.bgColor && prop.bgColor;
});
var BlockLayout = function BlockLayout(_ref) {
  var id = _ref.id,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === void 0 ? 'center' : _ref$verticalAlign,
    _ref$horizontalAlign = _ref.horizontalAlign,
    horizontalAlign = _ref$horizontalAlign === void 0 ? 'center' : _ref$horizontalAlign,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? '6px' : _ref$gap,
    padding = _ref.padding,
    margin = _ref.margin,
    border = _ref.border,
    cornerRadius = _ref.cornerRadius,
    height = _ref.height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Block, {
    id: id,
    verticalAlign: verticalAlign,
    horizontalAlign: horizontalAlign,
    textAlign: textAlign,
    textSize: textSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    bgColor: bgColor,
    color: color,
    gap: gap,
    padding: padding,
    margin: margin,
    border: border,
    cornerRadius: cornerRadius,
    height: height,
    width: width
  }, children);
};

var _templateObject$g, _templateObject2$4, _templateObject3$3, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  font-size: 1.42rem;\n  line-height: 2;\n  color: #202223;\n  font-weight: bold;\n"])));
styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  margin: 2rem 0 3rem;\n  ", ";\n"])), function (props) {
  return props.maxWidth ? "max-width: ".concat(props.maxWidth, ";") : null;
});
var colorCoding = {
  info: 'rgba(234, 244, 255, 1)',
  textInfo: 'rgba(0, 58, 90, 1)',
  success: '#d4edda',
  warning: '#fff3cd',
  danger: '#f8d7da',
  primary: '#cce5ff',
  secondary: '#e2e3e5'
};
var FlexDiv = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  & .grow {\n    flex-grow: 1;\n  }\n"])), function (props) {
  return props.flexdir ? "flex-direction: ".concat(props.flexdir, ";") : null;
}, function (props) {
  return props.margintop ? "margin-top: ".concat(props.margintop, ";") : null;
}, function (props) {
  return props.hide ? "display: none;" : null;
}, function (props) {
  return props.gap ? "gap: ".concat(props.gap, ";") : null;
}, function (props) {
  return props.columngap ? "column-gap: ".concat(props.columngap, ";") : null;
}, function (props) {
  return props.rowgap ? "row-gap: ".concat(props.rowgap, ";") : null;
}, function (props) {
  return props.ai ? "align-items: ".concat(props.ai) : 'start';
}, function (props) {
  return props.flexwrap ? "flex-wrap: ".concat(props.flexwrap, ";") : null;
}, function (props) {
  return props.height ? "height: ".concat(props.height, ";") : null;
}, function (props) {
  return props.width ? "width: ".concat(props.width, ";") : null;
}, function (props) {
  return props.maxwidth ? "max-width: ".concat(props.maxwidth, ";") : null;
}, function (props) {
  return props.minwidth ? "min-width: ".concat(props.minwidth, ";") : null;
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : null;
}, function (props) {
  return props.padding ? "padding: ".concat(props.padding, ";") : null;
}, function (props) {
  return props.jc ? "justify-content: ".concat(props.jc, ";") : null;
}, function (props) {
  return props.border ? "border: ".concat(props.border, ";") : null;
}, function (props) {
  return props.position ? "position: ".concat(props.position, ";") : null;
}, function (props) {
  return props.top ? "top: ".concat(props.top, ";") : null;
}, function (props) {
  return props.left ? "left: ".concat(props.left, ";") : null;
}, function (props) {
  return props.backgroundcolor ? "background-color: ".concat(props.backgroundcolor, ";") : null;
}, function (props) {
  return props.bg ? "background-color: ".concat(colorCoding[props.bg], ";") : null;
}, function (props) {
  return props.borderbottom ? "border-bottom: ".concat(props.borderbottom, ";") : null;
}, function (props) {
  return props.borderradius ? "border-radius: ".concat(props.borderradius, ";") : null;
}, function (props) {
  return props.zindex ? "z-index: ".concat(props.zindex, ";") : '0';
}, function (props) {
  return props.minheight ? "min-height: ".concat(props.minheight, ";") : null;
}, function (props) {
  return props.maxheight ? "max-height: ".concat(props.maxheight, ";") : null;
}, function (props) {
  return props.overflow ? "overflow: ".concat(props.overflow, ";") : null;
}, function (props) {
  return props.transform ? "transform: ".concat(props.transform, ";") : null;
}, function (props) {
  return props.boxshadow ? "box-shadow: ".concat(props.boxshadow, ";") : null;
}, function (props) {
  return props.boxsizing ? "box-shadow: ".concat(props.boxsizing, ";") : null;
}, function (props) {
  return props.fontSize ? "box-shadow: ".concat(props.fontSize, ";") : null;
});
styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  ", " ", "\n  label {\n    font-size: 1.4rem;\n    color: #1f1f1f;\n  }\n"])), function (props) {
  return props.maxWidth ? "max-width: ".concat(props.maxWidth, ";") : null;
}, function (props) {
  return props.pr ? "padding-right: ".concat(props.pr, ";") : null;
});
styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: #1f1f1f;\n  font-size: 1.4rem;\n  ", ";\n"])), function (props) {
  return props.mt ? "margin-top: ".concat(props.mt, ";") : null;
});
styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n"])));
styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  line-height: ", ";\n  padding: ", ";\n  padding: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (_ref) {
  var fontSize = _ref.fontSize;
  return fontSize;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var tone = _ref3.tone;
  return tone && colorCoding[tone];
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight;
}, function (_ref5) {
  var fontStyle = _ref5.fontStyle;
  return fontStyle;
}, function (_ref6) {
  var lineheight = _ref6.lineheight;
  return lineheight;
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding;
}, function (_ref8) {
  var margin = _ref8.margin;
  return margin;
}, function (_ref9) {
  var width = _ref9.width;
  return width;
}, function (_ref10) {
  var height = _ref10.height;
  return height;
});
styled.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", ";\n  align-items: ", ";\n  gap: ", ";\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  background: ", ";\n  border-radius: ", ";\n  border: ", ";\n  color: ", ";\n  text-align: center;\n  font-size: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  line-height: ", ";\n  cursor: pointer;\n  box-shadow: ", ";\n  classname: ", ";\n"])), function (_ref11) {
  var padding = _ref11.padding;
  return padding;
}, function (_ref12) {
  var alignButton = _ref12.alignButton;
  return alignButton;
}, function (_ref13) {
  var gap = _ref13.gap;
  return gap;
}, function (_ref14) {
  var width = _ref14.width;
  return width;
}, function (_ref15) {
  var height = _ref15.height;
  return height;
}, function (_ref16) {
  var backgroundColor = _ref16.backgroundColor;
  return backgroundColor;
}, function (_ref17) {
  var background = _ref17.background;
  return background;
}, function (_ref18) {
  var borderRadius = _ref18.borderRadius;
  return borderRadius;
}, function (_ref19) {
  var border = _ref19.border;
  return border;
}, function (_ref20) {
  var color = _ref20.color;
  return color;
}, function (_ref21) {
  var fontSize = _ref21.fontSize;
  return fontSize;
}, function (_ref22) {
  var fontWeight = _ref22.fontWeight;
  return fontWeight;
}, function (_ref23) {
  var lineHeight = _ref23.lineHeight;
  return lineHeight;
}, function (_ref24) {
  var boxShadow = _ref24.boxShadow;
  return boxShadow;
}, function (_ref25) {
  var className = _ref25.className;
  return className;
});

var _templateObject$f;
var StyledComponent = styled.p(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  font-size: ", ";\n  text-align: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  white-space: ", ";\n  margin: ", ";\n  max-width: ", ";\n  overflow-wrap: ", ";\n  word-break: ", ";\n"])), function (prop) {
  return prop.textSize || '14px';
}, function (prop) {
  return prop.textAlign || 'start';
}, function (prop) {
  return prop.fontFamily || 'inherit';
}, function (prop) {
  return prop.fontWeight || 400;
}, function (prop) {
  return prop.fontStyle || 'normal';
}, function (prop) {
  return prop.color || '#000000';
}, function (prop) {
  return prop.overflow || 'visible';
}, function (prop) {
  return prop.textOverflow || 'clip';
}, function (prop) {
  return prop.whiteSpace || 'normal';
}, function (prop) {
  return prop.margin || '0';
}, function (prop) {
  return prop.maxWidth || '100%';
}, function (prop) {
  return prop.overflowWrap || 'break-word';
}, function (prop) {
  return prop.wrapMode || 'break-word';
});
var Text$1 = function Text(_ref) {
  var children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    textSize = _ref.textSize,
    textAlign = _ref.textAlign,
    fontFamily = _ref.fontFamily,
    fontWeight = _ref.fontWeight,
    fontStyle = _ref.fontStyle,
    color = _ref.color,
    overflow = _ref.overflow,
    textOverflow = _ref.textOverflow,
    whiteSpace = _ref.whiteSpace,
    margin = _ref.margin,
    maxWidth = _ref.maxWidth,
    overflowWrap = _ref.overflowWrap,
    wordBreak = _ref.wordBreak;
  return /*#__PURE__*/React.createElement(StyledComponent, {
    as: as,
    textSize: textSize,
    textAlign: textAlign,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    color: color,
    overflow: overflow,
    textOverflow: textOverflow,
    whiteSpace: whiteSpace,
    margin: margin,
    maxWidth: maxWidth,
    overflowWrap: overflowWrap,
    wordBreak: wordBreak
  }, children);
};

var _templateObject$e;
var Line = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n\n  & > * {\n    display: none;\n  }\n"])), function (props) {
  return props.type === 'Vertical' ? "\n      width: ".concat(props.thickness ? props.thickness : 1, "px;\n      height: 100%;\n    ") : "\n      height: ".concat(props.thickness ? props.thickness : 1, "px;\n      width: 100%;\n    ");
}, function (prop) {
  return prop.color ? prop.color : '#DEDEDE';
});
var Divider = function Divider(_ref) {
  var _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 1 : _ref$thickness,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'rgba(222, 222, 222, 1)' : _ref$color,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? '#000' : _ref$textColor,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '12px' : _ref$fontSize,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? '0px' : _ref$margin,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Horizontal' : _ref$type,
    mainHeight = _ref.mainHeight;
  return /*#__PURE__*/React.createElement(FlexDiv, {
    ai: "center",
    flexdir: type === 'Vertical' ? 'column' : 'row',
    height: mainHeight,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Line, {
    thickness: thickness,
    color: color,
    type: type
  }, /*#__PURE__*/React.createElement("div", null)), text && (/*#__PURE__*/React.createElement(Text$1, {
    margin: margin,
    color: textColor,
    textSize: fontSize
  }, text)), /*#__PURE__*/React.createElement(Line, {
    thickness: thickness,
    color: color,
    type: type
  }, /*#__PURE__*/React.createElement("div", null)));
};

var _templateObject$d;
var Inline = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n  padding: ", ";\n  margin: ", ";\n  border: ", ";\n  border-radius: ", ";\n  flex-wrap: ", ";\n  color: ", ";\n  background-color: ", ";\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.textAlign && prop.textAlign;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (prop) {
  return prop.direction && alignment[prop.direction];
}, function (prop) {
  return prop.horizontalAlign && alignment[prop.horizontalAlign];
}, function (prop) {
  return prop.verticalAlign && alignment[prop.verticalAlign];
}, function (prop) {
  return prop.gap && prop.gap;
}, function (prop) {
  return prop.padding && prop.padding;
}, function (prop) {
  return prop.margin && prop.margin;
}, function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.cornerRadius && prop.cornerRadius;
}, function (prop) {
  return prop.wrap === false ? 'nowrap' : 'wrap';
}, function (prop) {
  return prop.color && prop.color;
}, function (prop) {
  return prop.bgColor && prop.bgColor;
});
var InlineLayout = function InlineLayout(_ref) {
  var id = _ref.id,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === void 0 ? 'center' : _ref$verticalAlign,
    _ref$horizontalAlign = _ref.horizontalAlign,
    horizontalAlign = _ref$horizontalAlign === void 0 ? 'center' : _ref$horizontalAlign,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'normal' : _ref$direction,
    gap = _ref.gap,
    wrap = _ref.wrap,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    padding = _ref.padding,
    margin = _ref.margin,
    border = _ref.border,
    cornerRadius = _ref.cornerRadius,
    children = _ref.children,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width;
  return /*#__PURE__*/React.createElement(Inline, {
    id: id,
    verticalAlign: verticalAlign,
    horizontalAlign: horizontalAlign,
    direction: direction,
    gap: gap,
    textAlign: textAlign,
    textSize: textSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    bgColor: bgColor,
    color: color,
    wrap: wrap,
    padding: padding,
    margin: margin,
    border: border,
    cornerRadius: cornerRadius,
    height: height,
    width: width
  }, children);
};

var img$d = "data:image/svg+xml,%3csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M16.2 8.99922H1.79995M1.79995 8.99922L8.09995 15.2992M1.79995 8.99922L8.09995 2.69922' stroke='rgba(112%2c 112%2c 112%2c 1)' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var _templateObject$c;
var StyledBadge = styled.button(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n\n  & img {\n    margin-right: 4px;\n    width: 14px;\n    height: 14px;\n  }\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.bgColor ? prop.bgColor : tone[prop.kind];
}, function (prop) {
  return prop.color ? prop.color : text[prop.kind];
}, function (prop) {
  return prop.size === 'small' ? '1px 7px' : prop.size === 'medium' ? '2px 8px' : prop.size === 'large' && '4px 8px';
}, function (prop) {
  return prop.kind === 'plain' ? '#DEDEDE' : 'transparent';
}, function (prop) {
  return prop.shape === 'round' ? '20px' : '10px';
});
var Badge = function Badge(_ref) {
  var _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'default' : _ref$kind,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'round' : _ref$shape,
    icon = _ref.icon,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 'Badge' : _ref$children;
  return /*#__PURE__*/React.createElement(StyledBadge, {
    kind: kind,
    textSize: textSize,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    bgColor: bgColor,
    color: color,
    size: size,
    shape: shape,
    icon: icon,
    style: {
      fontFamily: fontFamily
    }
  }, icon, " ", children);
};

var _getMdComponentAst = function getMdComponentAst(ast) {
  var components = {
    title: {
      component: 'heading',
      type: 'block',
      attributes: [{
        key: 'rank',
        value: 'level'
      }]
    },
    text: {
      component: 'paragraph',
      type: 'component'
    },
    textWithBlock: {
      component: 'paragraph',
      type: 'block'
    },
    italic: {
      component: 'italic',
      type: 'block',
      properties: {
        fontStyle: 'italic'
      }
    },
    bold: {
      component: 'bold',
      type: 'block',
      properties: {
        fontWeight: '700'
      }
    },
    break: {
      component: 'break',
      type: 'component'
    }
  };
  var componentAst = [];
  // creating a new ast based on our logic to concatenate all the blocks in one single array
  addLineBreaksInMdAst(ast).forEach(function (node) {
    var nodeType = node.type;
    var componentToUse = components[nodeType];
    // check if component is not found then use default ones
    if (!componentToUse) {
      nodeType = (node === null || node === void 0 ? void 0 : node.block) ? 'textWithBlock' : 'text';
      componentToUse = components[nodeType];
    }
    var _componentToUse = componentToUse,
      properties = _componentToUse.properties,
      attributes = _componentToUse.attributes,
      component = _componentToUse.component;
    // creating a sub node with component and properties
    // sub node is basically a new node with modified properties
    var subNode = {
      component: component
    };
    // looping over all the attributes to extract property from node and reassign with different key
    // eslint-disable-next-line no-unused-expressions
    attributes === null || attributes === void 0 ? void 0 : attributes.forEach(function (attribute) {
      subNode[attribute.value] = node[attribute.key];
    });
    if (properties) subNode.props = properties;
    //  we again recursively call the function to get the block nodes
    // blocks are same as of nodes
    if (components[nodeType].type === 'block' && node.block) {
      subNode.blocks = _getMdComponentAst(node.block.map(function (block) {
        return Object.assign(Object.assign({}, block), {
          // we keep these fields same as parent ones to keep them unique
          // because blocks are normal blocks without any info about parents
          type: nodeType,
          rank: node.rank,
          bullet: node.bullet
        });
      }));
    } else {
      subNode.content = (node === null || node === void 0 ? void 0 : node.text) || '';
    }
    subNode.bullet = (node === null || node === void 0 ? void 0 : node.bullet) || '';
    componentAst.push(subNode);
  });
  return componentAst;
};
// creates a new ast with line breaks as separate nodes all line breaks are extracted from strings
var addLineBreaksInMdAst = function addLineBreaksInMdAst(ast) {
  var updatedAst = [];
  ast.forEach(function (node, i) {
    var _a, _b;
    // checks for line breaks in the text
    if ((_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.includes('\n')) {
      // split string by line breaks and add each line as a separate node
      var astWithBreaks = node.text.split('\n').reduce(function (acc, content, index) {
        // first push line break and then content
        if (index) acc.push('\n');
        if (content !== '') acc.push(content);
        return acc;
      }, []);
      // based on line breaks, add break or text nodes
      astWithBreaks.forEach(function (content) {
        updatedAst.push({
          type: content === '\n' ? 'break' : node.type,
          text: content
        });
      });
    }
    // checks for list followed by list because it should have a line break after every list item
    else if (node.type === 'list' && ((_b = ast === null || ast === void 0 ? void 0 : ast[i + 1]) === null || _b === void 0 ? void 0 : _b.type) === 'list') {
      updatedAst.push(node);
      updatedAst.push({
        type: 'break',
        text: '\n'
      });
    } else updatedAst.push(node);
  });
  return updatedAst;
};
var Heading = function Heading(props) {
  return /*#__PURE__*/React.createElement(Text$1, Object.assign({
    fontWeight: "600"
  }, props));
};
var MdComponentsConfig = {
  heading: {
    component: Heading,
    additionalProps: {
      level: {
        name: 'textSize',
        values: {
          1: '20px',
          2: '16px',
          3: '14px'
        }
      },
      textAlign: {
        name: 'textAlign'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  paragraph: {
    component: Text$1,
    additionalProps: {
      fontSize: {
        name: 'textSize'
      },
      textAlign: {
        name: 'textAlign'
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  italic: {
    component: Text$1,
    props: {
      fontStyle: 'italic'
    },
    additionalProps: {
      fontSize: {
        name: 'textSize'
      },
      textAlign: {
        name: 'textAlign'
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  bold: {
    component: Text$1,
    props: {
      fontWeight: '600'
    },
    additionalProps: {
      fontSize: {
        name: 'textSize'
      },
      textAlign: {
        name: 'textAlign'
      },
      color: {
        name: 'color'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  }
};
var getProps = function getProps(componentType, props) {
  var _a;
  var componentProps = {};
  Object.keys(props).forEach(function (prop) {
    var _a, _b;
    // based on props from config we extract additional props
    var propConfig = (_b = (_a = MdComponentsConfig[componentType]) === null || _a === void 0 ? void 0 : _a.additionalProps) === null || _b === void 0 ? void 0 : _b[prop];
    if (propConfig) {
      // if prop exist we assign it to component props
      var propName = propConfig.name;
      componentProps[propName] = propConfig.values ? propConfig.values[props[prop]] : props[prop];
    }
  });
  // extracting existing props from config
  var existingProps = ((_a = MdComponentsConfig[componentType]) === null || _a === void 0 ? void 0 : _a.props) || {};
  return Object.assign(Object.assign({}, componentProps), existingProps);
};
// now from our own ast we extract components based on line breaks
var getMdComponentsFromMd = function getMdComponentsFromMd(mdAst) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  //  components are 2 level array, f
  // first level is for vertical displaying components
  // and inside first there's nested second level which is used to display components horizontally
  // [              ---> first level vertical
  //   ['level 1']           ---> second level horizontal
  //   ['level 2']
  // ],
  // [
  //  ['level 3']
  // ]
  // it will look something like this in preview
  // level 1 level 2
  // level 3
  var components = [[]];
  // tracking index of second level of array
  var nestedComponentActiveIndex = 0;
  var handleBreak = function handleBreak(node) {
    var noOfEmptyLines =
    // - 2 because one break is used to change the line
    node.content.replaceAll('\n', 'b').split('b').length - 2;
    var areMultipleLineBreaks = noOfEmptyLines > 0;
    // if the nested array exist then we push a text element with
    // hidden white color for line break to be visible
    if (components[nestedComponentActiveIndex] && !areMultipleLineBreaks) components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement("div", {
      style: {
        color: 'transparent'
      }
    }, "h"));
    // if there're multiple line breaks then push hidden text elem for each line break
    if (areMultipleLineBreaks) for (var index = 0; index < noOfEmptyLines; index += 1) {
      components.push([]);
      // after each line break we increment the index of nested array
      // so it goes to next line
      nestedComponentActiveIndex += 1;
      components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement("div", {
        style: {
          color: 'transparent'
        }
      }, "h"));
    }
    // at last we again push an empty nested array so all other elements can be in same level
    components.push([]);
    nestedComponentActiveIndex += 1;
  };
  mdAst.forEach(function (node) {
    // if there're blocks we first concatenate all the blocks in one single array
    if (node.blocks) {
      node.blocks.forEach(function (block) {
        // handling breaks in block
        if (block.component === 'break') handleBreak(block);else {
          var ComponentToUse = MdComponentsConfig[block.component].component;
          // we extract all the component props from config which component needs
          var props = getProps(block.component, Object.assign(Object.assign({}, block), additionalProps));
          // at last we push nested components in nested array
          components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement(ComponentToUse, Object.assign({
            as: 'span'
          }, props), block.bullet || '', " ", block.content));
        }
      });
    } else if (node.component === 'break') {
      handleBreak(node);
    } else {
      // if it's not a block we repeat above steps but for node
      var ComponentToUse = MdComponentsConfig[node.component].component;
      var props = getProps(node.component, Object.assign(Object.assign({}, node), additionalProps));
      components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement(ComponentToUse, Object.assign({
        as: 'span'
      }, props), node.bullet || '', " ", node.content));
    }
  });
  return components;
};
var verticalAlign = {
  left: 'start',
  center: 'end',
  right: 'center'
};
var getMd = function getMd() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var width = arguments.length > 2 ? arguments[2] : undefined;
  var alignment = arguments.length > 3 ? arguments[3] : undefined;
  var ast = md(string); // returns md from library
  var mdd = _getMdComponentAst(ast); // modifies md to our own ast
  var components = getMdComponentsFromMd(mdd, props); // creating component tree from our mdd ast
  return /*#__PURE__*/React.createElement(BlockLayout, {
    width: width,
    flexdir: "column",
    verticalAlign: verticalAlign[alignment]
  }, components.map(function (subComponents) {
    return /*#__PURE__*/React.createElement(InlineLayout, {
      horizontalAlign: 'start'
    }, subComponents.length > 0 ? subComponents.reduce(function (acc, component, index) {
      // If it's the first element, just return it
      if (index === 0) return component;
      // Otherwise, clone the accumulated elements and add the new component
      return /*#__PURE__*/React.cloneElement(acc, {}, [].concat(_toConsumableArray(React.Children.toArray(acc.props.children)), [component]));
    }) : null);
  }));
};
var useMd = function useMd() {
  return function (string, props, alignment) {
    return getMd(string, props, alignment);
  };
};
var MdText = function MdText(_ref) {
  var children = _ref.children,
    fontSize = _ref.fontSize,
    alignment = _ref.alignment,
    color = _ref.color,
    fontWeight = _ref.fontWeight,
    fontFamily = _ref.fontFamily,
    width = _ref.width;
  var md = useMd();
  return md(children, {
    fontSize: fontSize,
    alignment: alignment,
    color: color,
    fontWeight: fontWeight,
    fontFamily: fontFamily
  }, width, alignment);
};

var _templateObject$b;
var Dialog$1 = styled.dialog(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  width: ", ";\n  max-width: 750px;\n  min-width: 300px;\n  padding: 0;\n  border: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 11px;\n  &::backdrop {\n    background-color: #0000007f;\n    opacity: 100%;\n  }\n  box-shadow:\n    0 -2px 4px rgba(0, 0, 0, 0.08),\n    0 1px 1px rgba(0, 0, 0, 0.028),\n    0 3px 3px rgba(0, 0, 0, 0.035),\n    0 6px 6px rgba(0, 0, 0, 0.045),\n    0 12px 12px rgba(0, 0, 0, 0.055),\n    0 32px 32px rgba(0, 0, 0, 0.08);\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.textAlign && prop.textAlign;
}, function (prop) {
  return prop.isMobile ? '90vw' : '60vw';
}, function (prop) {
  return prop.color && prop.color;
}, function (prop) {
  return prop.bgColor && prop.bgColor;
});
var Modal = function Modal(_ref) {
  var openModal = _ref.openModal,
    closeModal = _ref.closeModal,
    back = _ref.back,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Modal' : _ref$title,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'semi-bold' : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    locationFontFamily = _ref.locationFontFamily;
    _ref.locationColor;
    var locationTextSize = _ref.locationTextSize,
    selectedLocationDisplayName = _ref.selectedLocationDisplayName,
    hideLocationOptions = _ref.hideLocationOptions,
    children = _ref.children,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === void 0 ? false : _ref$isAdmin;
  var ref = useRef(null);
  useEffect(function () {
    var _a, _b;
    if (openModal) {
      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.showModal();
    } else {
      (_b = ref.current) === null || _b === void 0 ? void 0 : _b.close();
    }
  }, [openModal]);
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    ref: ref,
    isAdmin: isAdmin
  }, /*#__PURE__*/React.createElement(BlockLayout, {
    gap: '0px',
    height: "auto"
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    padding: '10px 12px',
    bgColor: bgColor,
    horizontalAlign: "between",
    wrap: false,
    height: "auto"
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start",
    textSize: textSize,
    fontFamily: fontFamily,
    textAlign: textAlign,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    color: color,
    gap: "7px",
    height: "auto",
    wrap: false,
    width: "auto"
  }, back && (/*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    padding: "0",
    onClick: back,
    iconBefore: /*#__PURE__*/React.createElement("img", {
      src: img$d,
      alt: "arrow-left"
    }),
    iconBeforeSize: 18,
    iconSpacing: 0
  })), /*#__PURE__*/React.createElement(MdText, {
    fontSize: textSize,
    alignment: textAlign,
    color: color,
    fontWeight: fontWeight,
    fontFamily: fontFamily,
    width: 'auto'
  }, title), !hideLocationOptions && /*#__PURE__*/React.createElement(Badge, {
    kind: "plain",
    icon: /*#__PURE__*/React.createElement(Marker, {
      color: color,
      size: locationTextSize
    }),
    // below feilds are hardcoded, coz these setting are not being handled in admin
    bgColor: bgColor,
    textSize: locationTextSize,
    fontFamily: locationFontFamily,
    fontWeight: 'semi-bold',
    color: color
  }, selectedLocationDisplayName)), /*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    padding: "0",
    onClick: closeModal,
    iconSpacing: 0
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: color,
    size: "24px"
  }))), /*#__PURE__*/React.createElement(Divider, {
    color: '#F5F5F5'
  }), children));
};
var ModalWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var isAdmin = _a.isAdmin,
    children = _a.children,
    otherProps = __rest(_a, ["isAdmin", "children"]);
  var isMobile = window.innerWidth < 768;
  if (isAdmin) return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      borderRadius: '5px',
      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.08),\n            0 1px 1px rgba(0, 0, 0, 0.028),\n            0 3px 3px rgba(0, 0, 0, 0.035),\n            0 6px 6px rgba(0, 0, 0, 0.045),\n            0 12px 12px rgba(0, 0, 0, 0.055),\n            0 32px 32px rgba(0, 0, 0, 0.08)"
    }
  }, children);
  return /*#__PURE__*/React.createElement(Dialog$1, Object.assign({
    ref: ref,
    isMobile: isMobile
  }, otherProps), children);
});
var Marker = function Marker(_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? '#000000' : _ref2$color,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? '14px' : _ref2$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1C5.686 1 3 3.686 3 7c0 3.5 3.5 7.5 6 9.5 2.5-2 6-6 6-9.5 0-3.314-2.686-6-6-6Zm0 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: color
  }));
};
var CloseIcon = function CloseIcon(_ref3) {
  var _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? '#000000' : _ref3$color,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? '24px' : _ref3$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80011 4.80078L12.0001 12.0008M19.2001 19.2008L12.0001 12.0008M12.0001 12.0008L19.2001 4.80078M12.0001 12.0008L4.80011 19.2008",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  }));
};

var ModalContainer = function ModalContainer(_ref) {
  var isOpen = _ref.isOpen,
    exit = _ref.exit,
    stage = _ref.stage,
    goBack = _ref.goBack,
    isAdmin = _ref.isAdmin,
    children = _ref.children,
    titleStyles = _ref.titleStyles,
    locationStyles = _ref.locationStyles,
    hideBackButton = _ref.hideBackButton,
    isShowBackBtn = _ref.isShowBackBtn,
    selectedLocationDisplayName = _ref.selectedLocationDisplayName,
    hideLocationOptions = _ref.hideLocationOptions;
  return /*#__PURE__*/React.createElement(Modal, {
    openModal: isOpen,
    closeModal: exit,
    title: stage === 0 ? 'Select the location you are buying for' : titleStyles.titleText,
    fontFamily: titleStyles.titleFontFamily,
    textSize: "".concat(titleStyles.titleFontSize, "px"),
    color: titleStyles.titleTextColor,
    bgColor: titleStyles.uploadPopupHeaderBackgroundColor,
    back: isShowBackBtn && stage > 0 && !hideBackButton && goBack,
    isAdmin: isAdmin,
    fontWeight: 500,
    locationColor: locationStyles.locationTextColor,
    locationTextSize: "".concat(locationStyles.locationFontSize, "px"),
    locationFontFamily: locationStyles.locationFontFamily,
    selectedLocationDisplayName: selectedLocationDisplayName,
    hideLocationOptions: hideLocationOptions
  }, children);
};

var _templateObject$a, _templateObject2$3, _templateObject3$2;
var ChoiceButton = styled.input(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  appearance: unset;\n  border-radius: 50%;\n  min-width: 18px;\n  min-height: 18px;\n  width: 18px;\n  height: 18px;\n  border: 1px solid #dedede;\n  transition: 0.2s all linear;\n  margin: 3px 8px 3px 3px;\n  &:checked {\n    border: 6px solid ", ";\n  }\n"])), function (props) {
  return props.selectorColor;
});
var ChoiceBox = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 5px;\n  padding: 14px;\n  cursor: pointer;\n  transition: 0.3s all ease-in-out;\n\n  & * {\n    cursor: pointer;\n  }\n"])), function (prop) {
  return prop.fontFamily || 'inherit';
}, function (prop) {
  return prop.textSize || '1rem';
}, function (prop) {
  return prop.fontWeight || 400;
}, function (prop) {
  return prop.fontStyle || 'normal';
}, function (prop) {
  return prop.textAlign || 'start';
}, function (props) {
  return props.selected ? props.borderColor : '#dedede';
}, function (props) {
  return props.selected ? props.backgroundColor : '#ffffff';
});
var LabelContainer = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var Choice = function Choice(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type,
    name = _ref.name,
    label = _ref.label,
    value = _ref.value,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'start' : _ref$textAlign,
    _ref$textSize = _ref.textSize,
    textSize = _ref$textSize === void 0 ? '1rem' : _ref$textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    _ref$selectorColor = _ref.selectorColor,
    selectorColor = _ref$selectorColor === void 0 ? '#000000' : _ref$selectorColor,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? '#000000' : _ref$borderColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? '#FAFAFA' : _ref$backgroundColor,
    icon = _ref.icon,
    _onClick = _ref.onClick,
    id = _ref.id;
  var selected = value === id;
  return /*#__PURE__*/React.createElement(ChoiceBox, {
    textAlign: textAlign,
    textSize: textSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    selectorColor: selectorColor,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    selected: selected,
    onClick: function onClick() {
      return _onClick(id);
    }
  }, /*#__PURE__*/React.createElement(ChoiceButton, {
    type: type,
    name: name,
    id: id,
    value: id,
    checked: selected,
    selectorColor: selectorColor
  }), /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label), icon && /*#__PURE__*/React.createElement("div", null, icon)));
};

var _templateObject$9;
var StyledChoiceList = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 14px;\n"])));
var ChoiceList = function ChoiceList(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type,
    options = _ref.options,
    onChange = _ref.onChange,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === void 0 ? 'normal' : _ref$fontStyle,
    _ref$selectorColor = _ref.selectorColor,
    selectorColor = _ref$selectorColor === void 0 ? '#4CAF50' : _ref$selectorColor,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? '#4CAF50' : _ref$borderColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? '#E8F5E9' : _ref$backgroundColor,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(StyledChoiceList, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Choice, {
      key: option.id,
      id: option.id,
      type: type,
      name: option.name,
      label: option.name,
      value: value,
      textAlign: textAlign,
      textSize: textSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontStyle: fontStyle,
      selectorColor: selectorColor,
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      onClick: onChange
    });
  }));
};

var _templateObject$8, _templateObject2$2, _templateObject3$1;
var Div = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n"])));
var Text = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  padding: ", ";\n  gap: ", ";\n\n  & img {\n    width: 12px;\n    height: 12px;\n    margin-right: 11px;\n  }\n\n  &:has(input:focus) {\n    border: 1px solid rgba(23, 115, 176, 1);\n  }\n\n  ", "\n"])), function (props) {
  return props.error ? 'red' : props.borderColor || '#dedede';
}, function (props) {
  return props.borderRadius || '5px';
}, function (props) {
  return props.backgroundColor || 'transparent';
}, function (props) {
  return props.padding || '14px 11px';
}, function (props) {
  return props.gap || '8px';
}, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n    background-color: #f2f2f2;\n  ";
});
var Input$1 = styled.input(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  border: none;\n  margin: 0;\n  padding: 0;\n  &::placeholder {\n    color: #707070;\n  }\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n  box-shadow: none;\n  font-family: inherit;\n\n  ", "\n"])), function (props) {
  return props.disabled && "\n    background-color: #f2f2f2;\n    pointer-events: none;\n  ";
});
var TextField = function TextField(_ref) {
  var icon = _ref.icon,
    error = _ref.error,
    gap = _ref.gap,
    handleChange = _ref.handleChange,
    disabled = _ref.disabled,
    backgroundColor = _ref.backgroundColor,
    borderRadius = _ref.borderRadius,
    borderColor = _ref.borderColor,
    padding = _ref.padding;
  return /*#__PURE__*/React.createElement(Div, null, /*#__PURE__*/React.createElement(Text, {
    gap: gap,
    error: error,
    disabled: disabled,
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    borderColor: borderColor,
    padding: padding
  }, icon && /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "icon"
  }), /*#__PURE__*/React.createElement(Input$1, {
    type: "text",
    placeholder: "Label",
    onChange: handleChange,
    disabled: disabled
  })), error && /*#__PURE__*/React.createElement(Text$1, {
    color: "red"
  }, error));
};

var LocationSelect = function LocationSelect(_ref) {
  var next = _ref.next,
    locations = _ref.locations,
    themeProps = _ref.themeProps,
    selectedLocation = _ref.selectedLocation,
    setSelectedLocation = _ref.setSelectedLocation;
  var locationSelectHandler = function locationSelectHandler(v) {
    var selected = locations.find(function (elem) {
      return elem.id === v;
    });
    if (selected) setSelectedLocation(selected);
  };
  var _useState = useState(locations),
    _useState2 = _slicedToArray(_useState, 2),
    showOptions = _useState2[0],
    setShowOptions = _useState2[1];
  var autoComplete = function autoComplete(event) {
    var searchQuery = event.currentTarget.value;
    if (searchQuery === '') {
      setShowOptions(locations);
    } else {
      setShowOptions(locations.filter(function (location) {
        if (location.name.includes(searchQuery)) return location;
      }));
    }
  };
  return /*#__PURE__*/React.createElement(BlockLayout, {
    horizontalAlign: "start",
    gap: "14px"
  }, /*#__PURE__*/React.createElement(TextField, {
    handleChange: autoComplete
  }), /*#__PURE__*/React.createElement(ChoiceList, {
    type: "radio",
    options: showOptions,
    textSize: "".concat(themeProps.location.locationFontSize, "px"),
    fontFamily: themeProps.location.locationFontFamily,
    onChange: locationSelectHandler,
    value: selectedLocation.id
  }), /*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    onClick: next,
    fontFamily: themeProps.uploadCSVButton.uploadCSVButtonFontFamily,
    textSize: "".concat(themeProps.uploadCSVButton.uploadButtonFontSize, "px"),
    color: themeProps.uploadCSVButton.uploadCSVButtonTextColor,
    bgColor: themeProps.uploadCSVButton.uploadCSVButtonBackgroundColor,
    padding: "18px 20px"
  }, "Next"));
};

var img$c = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_10764_19026)'%3e %3cpath d='M9.7999 3.50039V1.87039C9.7999 1.61082 9.58948 1.40039 9.3299 1.40039H4.6699C4.41033 1.40039 4.1999 1.61082 4.1999 1.87039V3.50039M9.7999 3.50039H4.1999M9.7999 3.50039H11.1999M12.5999 3.50039H11.1999M4.1999 3.50039H2.7999M1.3999 3.50039H2.7999M2.7999 3.50039V12.1304C2.7999 12.39 3.01033 12.6004 3.2699 12.6004H10.7299C10.9895 12.6004 11.1999 12.39 11.1999 12.1304V3.50039M5.59435 6.30039V9.80039M8.3999 6.30039V9.80039' stroke='%23707070' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_10764_19026'%3e %3crect width='14' height='14' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e%3c/svg%3e";

var _templateObject$7;
var StyledBar = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  box-sizing: border-box;\n  text-align: start;\n  width: inherit;\n  height: 14px;\n  padding: 0;\n\n  & span {\n    position: absolute;\n    box-sizing: border-box;\n    border-radius: 5px;\n    height: 100%;\n    transition: width 0.3s ease-in-out;\n  }\n\n  & span:nth-child(1) {\n    width: 100%;\n    border: 1px solid #dedede;\n    background-color: #f5f5f5;\n  }\n\n  & span:nth-child(2) {\n    width: ", "%;\n    background-color: #3e3e3e;\n  }\n"])), function (props) {
  return props.progress;
});
var ProgressBar = function ProgressBar(_ref) {
  var _ref$progress = _ref.progress,
    progress = _ref$progress === void 0 ? 0 : _ref$progress,
    title = _ref.title,
    titleTextSize = _ref.titleTextSize,
    titleFontFamily = _ref.titleFontFamily,
    titleColor = _ref.titleColor,
    helperText = _ref.helperText,
    helperTextSize = _ref.helperTextSize,
    helperFontFamily = _ref.helperFontFamily,
    helperTextColor = _ref.helperTextColor;
  return /*#__PURE__*/React.createElement(BlockLayout, {
    gap: "7px"
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "between",
    fontFamily: titleFontFamily
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: titleColor,
      fontSize: titleTextSize
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      color: helperTextColor,
      fontSize: titleTextSize
    }
  }, progress, "%")), /*#__PURE__*/React.createElement(StyledBar, {
    progress: progress
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start",
    fontFamily: helperFontFamily
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: helperTextColor,
      fontSize: helperTextSize
    }
  }, helperText)));
};

var img$b = "data:image/svg+xml,%3csvg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M3.55005 7H11.95' stroke='%23707070' stroke-width='1.4' stroke-linecap='round'/%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3csvg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M2.8501 6.99961H7.7501M7.7501 6.99961H12.6501M7.7501 6.99961L7.7501 2.09961M7.7501 6.99961L7.7501 11.8996' stroke='%23707070' stroke-width='1.4' stroke-linecap='round'/%3e%3c/svg%3e";

var _templateObject$6;
var StepperContainer = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #dedede;\n  border-radius: 5px;\n  text-align: start;\n  color: inherit;\n  background-color: ", ";\n  margin: 0;\n  padding: 11px;\n  min-width: max-content;\n  width: ", ";\n  box-sizing: border-box;\n  & > div:first-child {\n    line-height: normal;\n  }\n  & img {\n    width: 100%;\n    height: 100%;\n    max-width: 14px;\n    max-height: 14px;\n  }\n  & label {\n    color: #707070;\n    font-size: 12px;\n    padding-right: 11px;\n  }\n  & .stepper-value {\n    color: ", ";\n    font-size: ", ";\n    margin: auto;\n  };\n  width: -webkit-max-content;\n"])), function (prop) {
  return prop.bgColor ? prop.bgColor : 'inherit';
}, function (prop) {
  return prop.isMobile ? 'inherit' : '100%';
}, function (prop) {
  return prop.color && prop.color;
}, function (props) {
  return props.isMobile ? '12px' : 'inherit';
});
var Stepper = function Stepper(_ref) {
  _ref.label;
    var _ref$increment = _ref.increment,
    increment = _ref$increment === void 0 ? 1 : _ref$increment,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 10 : _ref$max,
    id = _ref.id,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? min : _ref$value,
    isMobile = _ref.isMobile,
    color = _ref.color,
    bgColor = _ref.bgColor;
  var add = function add() {
    if (value < max) {
      if (value + increment > max) {
        onChange(max);
      } else onChange(value + increment);
    }
  };
  var subtract = function subtract() {
    if (value > min) {
      if (value - increment < min) {
        onChange(min);
      } else onChange(value - increment);
    }
  };
  return /*#__PURE__*/React.createElement(StepperContainer, {
    isMobile: isMobile,
    color: color,
    bgColor: bgColor
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    padding: "0 0 0 0"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    padding: "0 11px 0 0",
    disabled: value === min,
    onClick: subtract
  }, /*#__PURE__*/React.createElement("img", {
    src: img$b,
    alt: "minus"
  }))), /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "stepper-value"
  }, value), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    padding: "0 0 0 11px",
    disabled: value === max,
    onClick: add
  }, /*#__PURE__*/React.createElement("img", {
    src: img$a,
    alt: "plus"
  })))));
};

var img$9 = "data:image/svg+xml,%3csvg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M6.9999 4.58372V7.30595M12.5999 7.50039C12.5999 10.5932 10.0927 13.1004 6.9999 13.1004C3.90711 13.1004 1.3999 10.5932 1.3999 7.50039C1.3999 4.4076 3.90711 1.90039 6.9999 1.90039C10.0927 1.90039 12.5999 4.4076 12.5999 7.50039ZM7.1999 10.3004C7.1999 10.4108 7.11036 10.5004 6.9999 10.5004C6.88945 10.5004 6.7999 10.4108 6.7999 10.3004C6.7999 10.1899 6.88945 10.1004 6.9999 10.1004C7.11036 10.1004 7.1999 10.1899 7.1999 10.3004ZM6.9974 10.2979H7.00207V10.3029H6.9974V10.2979Z' stroke='%23DD1D1D' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var _templateObject$5;
var Container$1 = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: inherit;\n  height: inherit;\n  background-color: ", ";\n  border-top: 1px solid #fdd8d8;\n  border-bottom: 1px solid #fdd8d8;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: start;\n  text-align: start;\n  padding: 8px 14px;\n  & img {\n    width: 14px;\n    height: 14px;\n    margin-right: 14px;\n  }\n  & div {\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n  }\n"])), function (props) {
  return props.bgColor && props.bgColor;
}, function (props) {
  return props.contentColor && props.contentColor;
}, function (props) {
  return props.contentFontFamily && props.contentFontFamily;
}, function (props) {
  return props.contentFontSize && props.contentFontSize;
});
var InlineError = function InlineError(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? 'Please add a minimum of 3 items' : _ref$content,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '#fef6f6' : _ref$bgColor,
    _ref$contentFontFamil = _ref.contentFontFamily,
    contentFontFamily = _ref$contentFontFamil === void 0 ? 'inherit' : _ref$contentFontFamil,
    contentFontSize = _ref.contentFontSize,
    _ref$contentColor = _ref.contentColor,
    contentColor = _ref$contentColor === void 0 ? '#640707' : _ref$contentColor,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(Container$1, {
    bgColor: bgColor,
    contentFontFamily: contentFontFamily,
    contentFontSize: contentFontSize,
    contentColor: contentColor,
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    src: img$9,
    alt: "error"
  }), /*#__PURE__*/React.createElement("div", null, content));
};

var TableHeader = function TableHeader(_ref) {
  var columnHeadings = _ref.columnHeadings,
    getCellStyles = _ref.getCellStyles;
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columnHeadings.map(function (heading) {
    return /*#__PURE__*/React.createElement("th", {
      key: heading,
      style: getCellStyles(heading),
      title: heading
    }, heading === "Actions" ? "" : heading);
  })));
};

var TableRow = function TableRow(_ref) {
  var row = _ref.row,
    columnHeadings = _ref.columnHeadings,
    getCellStyles = _ref.getCellStyles,
    getTextContent = _ref.getTextContent;
  return /*#__PURE__*/React.createElement("tr", null, columnHeadings.map(function (heading) {
    return /*#__PURE__*/React.createElement("td", {
      key: heading,
      className: row['Is Error'] === 'true' ? 'error-row' : undefined,
      style: getCellStyles(heading),
      title: heading in columnHeadings ? row[heading] : undefined
    }, getTextContent(row[heading]));
  }));
};

var ErrorRow = function ErrorRow(_ref) {
  var row = _ref.row,
    columnHeadings = _ref.columnHeadings,
    themeProps = _ref.themeProps,
    getErrorText = _ref.getErrorText,
    incrementToken = _ref.incrementToken;
  return row['Is Error'] === 'true' && (/*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "error-row",
    colSpan: columnHeadings.length + 1,
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement(InlineError, {
    content: getErrorText(row['Error'], Number(row[incrementToken])),
    contentColor: themeProps.lineItemErrorTextColor,
    contentFontFamily: themeProps.lineItemErrorFontFamily,
    contentFontSize: themeProps.lineItemErrorFontSize
  }))));
};

var _templateObject$4, _templateObject2$1, _templateObject3, _templateObject4;
var MobileTableText = styled.p(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  margin: 4px 0 !important;\n  font-size: 12px;\n  line-height: 18px;\n  color: inherit;\n  width: ", ";\n  & span {\n    color: ", ";\n  }\n"])), function (prop) {
  return prop.width || '100%';
}, function (prop) {
  return prop.color && prop.color;
});
var MobileTable = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  border: 1px solid #dfdfdf;\n  border-radius: 5px;\n  width: 100%;\n"])));
var StyledTable = styled.table(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: inherit, sans-serif;\n  box-sizing: border-box;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: ", ";\n  border-radius: ", ";\n  & th {\n    padding: ", ";\n    border-bottom: ", ";\n    font-weight: 400;\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n    white-space: nowrap;\n  }\n  & td {\n    white-space: nowrap;\n    padding: ", ";\n    border-bottom: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n  }\n  & td.error-row {\n    background-color: #fef6f6;\n    border-bottom: none;\n  }\n  & tbody tr:last-child td {\n    border-bottom: none;\n  }\n"])), function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.cornerRadius ? prop.cornerRadius : '5px';
}, function (prop) {
  return prop.padding ? prop.padding : '8px';
}, function (prop) {
  return prop.border ? prop.border : '1px solid #E1E3E5';
}, function (prop) {
  return prop.headingFontSize ? prop.headingFontSize : '14';
}, function (prop) {
  return prop.headingColor ? prop.headingColor : '#707070';
}, function (prop) {
  return prop.headingAlign ? prop.headingAlign : 'center';
}, function (prop) {
  return prop.padding ? prop.padding : '8px';
}, function (prop) {
  return prop.border ? prop.border : '1px solid #E1E3E5';
}, function (prop) {
  return prop.contentFontSize ? prop.contentFontSize : '14';
}, function (prop) {
  return prop.contentColor ? prop.contentColor : '#000000';
}, function (prop) {
  return prop.contentAlign ? prop.contentAlign : 'center';
});
var StyledContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  overflow: auto;\n  max-height: 40vh;\n  border: 1px solid #e1e3e5;\n  border-radius: 5px;\n"])));
var columnWidths = {
  'Product Name': '250px',
  Available: '150px',
  'Minimum Quantity': '150px',
  'Variant SKU': '150px'
};
var getCellStyles = function getCellStyles(heading) {
  var baseStyles = {
    maxWidth: columnWidths[heading] || 'auto',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  };
  return heading in columnWidths ? baseStyles : {};
};
var getTextContent = function getTextContent(data) {
  return !data ? '-' : data;
};
var Table = function Table(_ref) {
  var headingFontSize = _ref.headingFontSize,
    contentFontSize = _ref.contentFontSize,
    headingColor = _ref.headingColor,
    contentColor = _ref.contentColor,
    padding = _ref.padding,
    borderColor = _ref.borderColor,
    borderWidth = _ref.borderWidth,
    cornerRadius = _ref.cornerRadius,
    tableData = _ref.tableData,
    onTableRowQuantityChange = _ref.onTableRowQuantityChange,
    onTableRowDelete = _ref.onTableRowDelete,
    themeProps = _ref.themeProps;
    _ref.isShowAvailableStock;
    _ref.isShowBarcode;
    var incrementToken = _ref.incrementToken,
    minQtyToken = _ref.minQtyToken,
    maxQtyToken = _ref.maxQtyToken,
    availableQtyToken = _ref.availableQtyToken,
    qtyToken = _ref.qtyToken,
    tableHeadings = _ref.tableHeadings;
  var isMobile = window.innerWidth < 768;
  var getErrorText = function getErrorText(error, incrementValue) {
    if (error === 'errorIncrementQuantityText') {
      return themeProps.errorIncrementQuantityText.replace('{increment_qty}', String(incrementValue));
    }
    return themeProps[error];
  };
  var getMaxStepperVal = function getMaxStepperVal(row) {
    if (row) {
      var maxQty = Number(row[maxQtyToken]) || 99999;
      return row[availableQtyToken] ? row[availableQtyToken] === '' ? maxQty : Number(row[availableQtyToken]) : maxQty;
    } else return 99999;
  };
  var getMinStepperVal = function getMinStepperVal(row) {
    if (row) {
      var minQty = Number(row[minQtyToken]) || 0;
      var min = Math.max(0, minQty);
      // as there is no stock min should be 0 so that the row can be ignored
      if (row && row[availableQtyToken] !== '' && Number(row[availableQtyToken]) <= 0) {
        return 0;
      }
      return min;
    }
  };
  var columnHeadings = tableHeadings || Object.keys(tableData[0]).filter(function (key) {
    return key !== "Error" && key !== "Is Error";
  });
  columnHeadings.push('Actions');
  var rowData = structuredClone(tableData).map(function (row, index) {
    row[qtyToken] = /*#__PURE__*/React.createElement(Stepper, {
      label: qtyToken,
      increment: +row[incrementToken] || 1,
      max: getMaxStepperVal(row),
      min: getMinStepperVal(row),
      onChange: function onChange(v) {
        return onTableRowQuantityChange(index, v);
      },
      value: +row[qtyToken],
      isMobile: isMobile,
      color: themeProps.orderTableContentTextColor,
      bgColor: row['Is Error'] === 'true' ? '#ffffff' : 'inherit'
    });
    row['Actions'] = /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onTableRowDelete(index);
      },
      kind: "plain",
      padding: "6px"
    }, /*#__PURE__*/React.createElement("img", {
      src: img$c,
      alt: "delete"
    }));
    return row;
  });
  if (isMobile) {
    return /*#__PURE__*/React.createElement(MobileTable, null, rowData.map(function (row, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BlockLayout, {
        gap: "14px",
        padding: "14px 7px"
      }, /*#__PURE__*/React.createElement(InlineLayout, {
        height: 'auto',
        horizontalAlign: "between"
      }, /*#__PURE__*/React.createElement(MobileTableText, {
        width: "85%",
        color: themeProps.orderTableContentTextColor
      }, /*#__PURE__*/React.createElement("span", null, columnHeadings[0], " ", " : "), /*#__PURE__*/React.createElement("span", null, row[columnHeadings[0]])), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return onTableRowDelete(index);
        },
        kind: "plain",
        padding: "0"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$c,
        alt: "delete"
      }))), columnHeadings.slice(1, columnHeadings.length - 1).map(function (heading) {
        return /*#__PURE__*/React.createElement(InlineLayout, {
          key: heading,
          horizontalAlign: "start"
        }, /*#__PURE__*/React.createElement(MobileTableText, {
          color: themeProps.orderTableContentTextColor
        }, /*#__PURE__*/React.createElement("span", null, heading, " ", " : "), /*#__PURE__*/React.createElement("span", null, getTextContent(row[heading]))));
      }), row['Is Error'] === 'true' && (/*#__PURE__*/React.createElement(InlineError, {
        content: getErrorText(row['Error'], Number(row.incrementToken)),
        contentColor: themeProps.lineItemErrorTextColor,
        contentFontFamily: themeProps.lineItemErrorFontFamily,
        contentFontSize: themeProps.lineItemErrorFontSize,
        style: {
          borderLeft: '1px solid #fdd8d8',
          borderRight: '1px solid #fdd8d8',
          borderRadius: '5px'
        }
      }))), index !== rowData.length - 1 && /*#__PURE__*/React.createElement(Divider, {
        color: "#E1E3E5"
      }));
    }));
  }
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledTable, {
    headingFontSize: headingFontSize,
    contentFontSize: contentFontSize,
    headingColor: headingColor,
    contentColor: contentColor,
    padding: padding,
    borderColor: borderColor,
    borderWidth: borderWidth,
    cornerRadius: cornerRadius,
    headingAlign: "start",
    contentAlign: "start"
  }, /*#__PURE__*/React.createElement(TableHeader, {
    columnHeadings: columnHeadings,
    getCellStyles: getCellStyles
  }), /*#__PURE__*/React.createElement("tbody", null, rowData.map(function (row, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(TableRow, {
      row: row,
      columnHeadings: columnHeadings,
      getCellStyles: getCellStyles,
      getTextContent: getTextContent
    }), /*#__PURE__*/React.createElement(ErrorRow, {
      row: row,
      columnHeadings: columnHeadings,
      themeProps: themeProps,
      getErrorText: getErrorText,
      incrementToken: incrementToken
    }));
  }))));
};

var img$8 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M12.0001 7.00039L12.0001 11.6671M21.6001 12.0004C21.6001 17.3023 17.302 21.6004 12.0001 21.6004C6.69812 21.6004 2.40005 17.3023 2.40005 12.0004C2.40005 6.69846 6.69812 2.40039 12.0001 2.40039C17.302 2.40039 21.6001 6.69846 21.6001 12.0004ZM12.3429 16.8004C12.3429 16.9897 12.1894 17.1432 12.0001 17.1432C11.8107 17.1432 11.6572 16.9897 11.6572 16.8004C11.6572 16.611 11.8107 16.4575 12.0001 16.4575C12.1894 16.4575 12.3429 16.611 12.3429 16.8004ZM11.9958 16.7961H12.0038V16.8047H11.9958V16.7961Z' stroke='%23DD1D1D' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M9.99999 14.4444C9.53975 14.4444 9.16666 14.0713 9.16667 13.6111L9.16674 9.72221C9.16675 9.26197 9.53985 8.88888 10.0001 8.88889C10.4603 8.8889 10.8334 9.262 10.8334 9.72224L10.8333 13.6111C10.8333 14.0714 10.4602 14.4445 9.99999 14.4444Z' fill='%234A4A4A'/%3e %3cpath d='M8.8889 6.66667C8.8889 6.05302 9.38636 5.55555 10 5.55555C10.6137 5.55555 11.1111 6.05302 11.1111 6.66667C11.1111 7.28032 10.6137 7.77778 10 7.77778C9.38636 7.77778 8.8889 7.28032 8.8889 6.66667Z' fill='%234A4A4A'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.7778 10C17.7778 14.2955 14.2956 17.7778 10 17.7778C5.70446 17.7778 2.22223 14.2955 2.22223 10C2.22223 5.70445 5.70446 2.22222 10 2.22222C14.2956 2.22222 17.7778 5.70445 17.7778 10ZM16.1111 10C16.1111 13.3751 13.3751 16.1111 10 16.1111C6.62493 16.1111 3.8889 13.3751 3.8889 10C3.8889 6.62493 6.62493 3.88889 10 3.88889C13.3751 3.88889 16.1111 6.62493 16.1111 10Z' fill='%234A4A4A'/%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.2143 6.6865L8.88918 11.6909C8.7092 11.9617 8.32614 11.9996 8.09657 11.7693L5.78576 9.45078M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00005 16.2008C5.0236 16.2008 1.80005 12.9772 1.80005 9.00078C1.80005 5.02433 5.0236 1.80078 9.00005 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078Z' stroke='rgba(10%2c 130%2c 32%2c 1)' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M12 9.60156L12 13.2016' stroke='%238F6900' stroke-width='1.4' stroke-linecap='round'/%3e %3ccircle cx='12.0001' cy='16.7999' r='0.342857' stroke='%238F6900' stroke-width='1.4'/%3e %3cpath d='M12.0038 16.7969H11.9958V16.8054H12.0038V16.7969Z' stroke='%238F6900' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M11.4669 3.39817C11.6944 2.97162 12.3058 2.97162 12.5333 3.39817L21.1261 19.5098C21.3408 19.9123 21.0491 20.3984 20.5929 20.3984H3.40723C2.95104 20.3984 2.65936 19.9123 2.87404 19.5098L11.4669 3.39817Z' stroke='%238F6900' stroke-width='1.4'/%3e%3c/svg%3e";

var List = function List(_ref) {
  var messages = _ref.messages,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'unordered' : _ref$type,
    className = _ref.className,
    listStyleType = _ref.listStyleType,
    fontFamily = _ref.fontFamily,
    fontSize = _ref.fontSize;
  var ListElement = type === 'ordered' ? 'ol' : 'ul';
  return /*#__PURE__*/React.createElement(ListElement, {
    className: className,
    style: {
      listStyleType: listStyleType,
      fontFamily: fontFamily,
      fontSize: fontSize
    }
  }, messages.map(function (message, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, message);
  }));
};

var _templateObject$3;
var getVariantStyles = function getVariantStyles(variant) {
  switch (variant) {
    case 'critical':
      return {
        bgColor: 'rgba(254, 246, 246, 1)',
        titleColor: 'rgba(66, 0, 0, 1)',
        contentColor: 'rgba(100, 7, 7, 1)',
        borderColor: 'rgba(253, 216, 216, 1)',
        icon: img$8
      };
    case 'info':
      return {
        bgColor: 'rgba(245, 245, 245, 1)',
        titleColor: 'rgba(28, 28, 28, 1)',
        contentColor: 'rgba(28, 28, 28, 1)',
        borderColor: 'rgba(227, 227, 227, 1)',
        icon: img$7
      };
    case 'success':
      return {
        bgColor: 'rgba(234, 251, 234, 1)',
        titleColor: 'rgba(16, 30, 17, 1)',
        contentColor: 'rgba(82, 132, 86, 1)',
        borderColor: 'rgba(177, 242, 180, 1)',
        icon: img$6
      };
    case 'warning':
      return {
        bgColor: 'rgba(255, 245, 235, 1)',
        titleColor: '#241700',
        contentColor: '#423100',
        borderColor: 'rgba(255, 222, 178, 1)',
        icon: img$5
      };
    default:
      return {
        bgColor: '#fef6f6',
        titleColor: '#420000',
        contentColor: '#640707',
        icon: img$8
      };
  }
};
var Container = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background-color: ", ";\n  border-radius: 5px;\n  border: 1px solid ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  text-align: start;\n  padding: 14px;\n  width: 100%;\n  & img {\n    width: 24px;\n    height: 24px;\n    margin-bottom: auto;\n    margin-right: 14px;\n  }\n  & .alert-title {\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    font-weight: 600;\n  }\n  & div ul {\n    margin: 7px 0 0 24px;\n    padding: 0;\n  }\n  & .alert-content {\n    overflow-wrap: anywhere;\n    white-space: pre-wrap;\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n  }\n"])), function (props) {
  return props.bgColor || getVariantStyles(props.variant).bgColor;
}, function (props) {
  return getVariantStyles(props.variant).borderColor;
}, function (props) {
  return props.titleFontFamily && props.titleFontFamily;
}, function (props) {
  return props.titleFontSize && props.titleFontSize;
}, function (props) {
  return props.titleColor || getVariantStyles(props.variant).titleColor;
}, function (props) {
  return props.contentColor || getVariantStyles(props.variant).contentColor;
}, function (props) {
  return props.contentFontFamily && props.contentFontFamily;
}, function (props) {
  return props.contentFontSize && props.contentFontSize;
});
var AlertBanner = function AlertBanner(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Alert! Please take the necessary actions.' : _ref$title,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? ['This is a default alert message.'] : _ref$messages,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'critical' : _ref$variant,
    titleFontFamily = _ref.titleFontFamily,
    titleFontSize = _ref.titleFontSize,
    titleColor = _ref.titleColor,
    bgColor = _ref.bgColor,
    contentFontFamily = _ref.contentFontFamily,
    contentFontSize = _ref.contentFontSize,
    contentColor = _ref.contentColor,
    _ref$contentBullets = _ref.contentBullets,
    contentBullets = _ref$contentBullets === void 0 ? true : _ref$contentBullets;
  var variantStyles = getVariantStyles(variant);
  var bannerContent = contentBullets ? (/*#__PURE__*/React.createElement(List, {
    className: "alert-content",
    messages: messages
  })) : messages.map(function (message, index) {
    return /*#__PURE__*/React.createElement("p", {
      className: "alert-content",
      key: index
    }, message);
  });
  return /*#__PURE__*/React.createElement(Container, {
    titleFontFamily: titleFontFamily,
    titleFontSize: titleFontSize,
    titleColor: titleColor,
    bgColor: bgColor || variantStyles.bgColor,
    contentFontFamily: contentFontFamily,
    contentFontSize: contentFontSize,
    contentColor: contentColor || variantStyles.contentColor,
    variant: variant
  }, /*#__PURE__*/React.createElement("img", {
    src: variantStyles.icon,
    alt: variant
  }), /*#__PURE__*/React.createElement(FlexDiv, {
    flexdir: "column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert-title"
  }, title), bannerContent));
};

var img$4 = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M5.60005 9.10039H7.70005M5.60005 7.00039H8.40005M5.60005 4.90039H7.00005M8.53771 1.53805L11.0624 4.06273C11.1505 4.15087 11.2 4.27042 11.2 4.39507V12.1304C11.2 12.39 10.9896 12.6004 10.73 12.6004H3.27005C3.01048 12.6004 2.80005 12.39 2.80005 12.1304V1.87039C2.80005 1.61082 3.01047 1.40039 3.27005 1.40039H8.20537C8.33002 1.40039 8.44957 1.44991 8.53771 1.53805Z' stroke='%23707070' stroke-width='1.4' stroke-linecap='round'/%3e%3c/svg%3e";

var _templateObject$2, _templateObject2;
var Input = styled.input(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n"])));
var Label = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  overflow-wrap: break-word;\n  cursor: pointer;\n  padding: 14px 22px;\n  margin-right: 1px;\n"])));
var FileUpload = function FileUpload(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? 'Upload' : _ref$content,
    handleFileUpload = _ref.handleFileUpload,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === void 0 ? false : _ref$isAdmin;
  var handleInput = function handleInput(e) {
    var _a;
    var inputEvent = e.currentTarget;
    var file = (_a = inputEvent.files) === null || _a === void 0 ? void 0 : _a[0];
    if (file) handleFileUpload(file);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    type: isAdmin ? "text" : "file",
    id: "upload",
    onInput: handleInput,
    accept: ".csv, .xlsx"
  }), /*#__PURE__*/React.createElement(Label, {
    htmlFor: "upload"
  }, content));
};

var img$3 = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M11.9 5.59961L7.31817 10.1814C7.14244 10.3571 6.85751 10.3571 6.68178 10.1814L2.09998 5.59961' stroke='black' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M11.9001 8.90039L7.24759 4.24788C7.1109 4.11119 6.88929 4.11119 6.75261 4.24788L2.1001 8.90039' stroke='black' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var CollapsibleCard = function CollapsibleCard(_ref) {
  var isAdmin = _ref.isAdmin,
    _ref$heightAdmin = _ref.heightAdmin,
    heightAdmin = _ref$heightAdmin === void 0 ? '40vh' : _ref$heightAdmin,
    _ref$heightDefault = _ref.heightDefault,
    heightDefault = _ref$heightDefault === void 0 ? '100%' : _ref$heightDefault,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? '10px' : _ref$gap,
    titleText = _ref.titleText,
    _ref$titleTextSize = _ref.titleTextSize,
    titleTextSize = _ref$titleTextSize === void 0 ? '16px' : _ref$titleTextSize,
    _ref$titleFontWeight = _ref.titleFontWeight,
    titleFontWeight = _ref$titleFontWeight === void 0 ? 500 : _ref$titleFontWeight,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? '#000' : _ref$titleColor,
    _ref$titleFontFamily = _ref.titleFontFamily,
    titleFontFamily = _ref$titleFontFamily === void 0 ? 'Arial, sans-serif' : _ref$titleFontFamily,
    _ref$buttonKind = _ref.buttonKind,
    buttonKind = _ref$buttonKind === void 0 ? 'plain' : _ref$buttonKind,
    _ref$buttonTextSize = _ref.buttonTextSize,
    buttonTextSize = _ref$buttonTextSize === void 0 ? '14px' : _ref$buttonTextSize,
    _ref$buttonTextColor = _ref.buttonTextColor,
    buttonTextColor = _ref$buttonTextColor === void 0 ? 'rgba(25, 124, 189, 1)' : _ref$buttonTextColor,
    _ref$buttonPadding = _ref.buttonPadding,
    buttonPadding = _ref$buttonPadding === void 0 ? '0' : _ref$buttonPadding,
    _ref$iconBeforeSize = _ref.iconBeforeSize,
    iconBeforeSize = _ref$iconBeforeSize === void 0 ? 12 : _ref$iconBeforeSize,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === void 0 ? 4 : _ref$iconSpacing,
    isContentVisible = _ref.isContentVisible,
    _ref$showText = _ref.showText,
    showText = _ref$showText === void 0 ? 'Show' : _ref$showText,
    _ref$hideText = _ref.hideText,
    hideText = _ref$hideText === void 0 ? 'Hide' : _ref$hideText,
    toggleContentVisibility = _ref.toggleContentVisibility,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(BlockLayout, {
    height: isAdmin ? heightAdmin : heightDefault,
    gap: gap
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    height: 'auto',
    horizontalAlign: "between"
  }, /*#__PURE__*/React.createElement(Text$1, {
    textSize: titleTextSize,
    fontWeight: titleFontWeight,
    color: titleColor,
    fontFamily: titleFontFamily
  }, titleText), /*#__PURE__*/React.createElement(Button, {
    kind: buttonKind,
    textSize: buttonTextSize,
    padding: buttonPadding,
    color: buttonTextColor,
    iconBefore: isContentVisible ? (/*#__PURE__*/React.createElement("img", {
      src: img$2,
      alt: "down-arrow"
    })) : (/*#__PURE__*/React.createElement("img", {
      src: img$3,
      alt: "up-arrow"
    })),
    iconBeforeSize: iconBeforeSize,
    iconSpacing: iconSpacing,
    onClick: toggleContentVisibility
  }, isContentVisible ? hideText : showText)), isContentVisible && children);
};

var _templateObject$1;
var IconContainer = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  cursor: ", ";\n  transition: ", ";\n\n  &:hover {\n    transform: ", ";\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) {
  return props.size || '24px';
}, function (props) {
  return props.size || '24px';
}, function (props) {
  return props.hoverEffect ? 'pointer' : 'default';
}, function (props) {
  return props.hoverEffect ? 'transform 0.2s ease-in-out' : 'none';
}, function (props) {
  return props.hoverEffect ? 'scale(1.1)' : 'none';
});
var Icon = function Icon(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    size = _ref.size,
    onClick = _ref.onClick,
    _ref$hoverEffect = _ref.hoverEffect,
    hoverEffect = _ref$hoverEffect === void 0 ? false : _ref$hoverEffect,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(IconContainer, {
    size: size,
    hoverEffect: hoverEffect,
    onClick: onClick,
    className: className,
    role: onClick ? 'button' : 'img',
    "aria-label": onClick ? alt : undefined
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }));
};

var img$1 = "data:image/svg+xml,%3csvg width='16' height='22' viewBox='0 0 16 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M14.6947 3.72195H13.0869V2.14975C13.0911 1.79771 12.9554 1.45839 12.7098 1.20623C12.4641 0.954066 12.1284 0.809658 11.7764 0.804688H5.28104C5.02739 0.806073 4.77668 0.859057 4.54415 0.960414C4.31163 1.06177 4.10216 1.20938 3.92849 1.39426L0.540182 4.98442C0.190702 5.3558 -0.00266099 5.8473 9.4122e-05 6.35725V16.9362C-0.00409253 17.2882 0.13154 17.6275 0.377234 17.8797C0.622927 18.1319 0.958616 18.2763 1.31065 18.2812H2.91917V19.8506C2.9139 20.2023 3.04828 20.5418 3.29287 20.7946C3.53746 21.0474 3.87231 21.1929 4.224 21.1992H14.6947C15.0464 21.1929 15.3813 21.0474 15.6259 20.7946C15.8706 20.5418 16.005 20.2023 15.9999 19.8506V5.06346C16.0042 4.71263 15.8692 4.37439 15.6246 4.12291C15.3799 3.87143 15.0455 3.72724 14.6947 3.72195ZM4.47928 2.93558V5.22367H2.31985L4.47928 2.93558ZM1.4584 6.68195H5.20842C5.30417 6.68197 5.399 6.66313 5.48747 6.6265C5.57595 6.58986 5.65634 6.53616 5.72405 6.46844C5.79176 6.40073 5.84547 6.32034 5.8821 6.23187C5.91874 6.14339 5.93758 6.04857 5.93755 5.95281C5.92481 5.89872 5.95752 2.31076 5.92865 2.26297H11.6286C11.6286 3.42995 11.6286 15.3202 11.6286 16.823H1.4584V6.68195ZM14.5416 19.7409H4.37745V18.2812H11.7764C12.1284 18.2762 12.4641 18.1318 12.7098 17.8797C12.9554 17.6275 13.0911 17.2882 13.0869 16.9361V5.18023H14.5416V19.7409Z' fill='%23707070'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M15.5579 3.60156L8.00145 14.9716C7.84397 15.2085 7.50885 15.2417 7.30798 15.0402L1.80078 9.51585' stroke='%23707070' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var CopyLinkBox = function CopyLinkBox(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'https://example.com/' : _ref$text,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '2px 14px' : _ref$padding,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '5px' : _ref$borderRadius,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'blue' : _ref$textColor,
    handleCopy = _ref.handleCopy,
    copied = _ref.copied;
  return /*#__PURE__*/React.createElement(InlineLayout, {
    border: "1px solid #DEDEDE",
    horizontalAlign: "between",
    padding: padding,
    cornerRadius: borderRadius,
    wrap: false,
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Text$1, {
    textSize: "14",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: textColor
  }, text), /*#__PURE__*/React.createElement(Icon, {
    src: copied ? img : img$1,
    alt: copied ? 'Copied' : 'Copy link',
    onClick: handleCopy,
    hoverEffect: true
  }));
};

var UploadModal = function UploadModal(_ref) {
  var themeProps = _ref.themeProps,
    watchTutorialLink = _ref.watchTutorialLink,
    isShowWatchTutorial = _ref.isShowWatchTutorial,
    handleFileUpload = _ref.handleFileUpload,
    isHideDownloadButton = _ref.isHideDownloadButton,
    onDownloadButtonClick = _ref.onDownloadButtonClick,
    downloadBtnLoading = _ref.downloadBtnLoading,
    isShowProgressBar = _ref.isShowProgressBar,
    progressValue = _ref.progressValue,
    processingText = _ref.processingText,
    fileName = _ref.fileName,
    tableData = _ref.tableData,
    isShowOrderTable = _ref.isShowOrderTable,
    onDeleteFile = _ref.onDeleteFile,
    errorList = _ref.errorList,
    onTableRowQuantityChange = _ref.onTableRowQuantityChange,
    createOrderLoading = _ref.createOrderLoading,
    isShowCreateOrderBtn = _ref.isShowCreateOrderBtn,
    showOrderURL = _ref.showOrderURL,
    createOrderUrl = _ref.createOrderUrl,
    onCreateOrderClick = _ref.onCreateOrderClick,
    fileUploadError = _ref.fileUploadError,
    downloadButtonText = _ref.downloadButtonText,
    onTableRowDelete = _ref.onTableRowDelete,
    isAdmin = _ref.isAdmin,
    setIsShowOrderTable = _ref.setIsShowOrderTable,
    isShowAvailableStock = _ref.isShowAvailableStock,
    isShowBarcode = _ref.isShowBarcode,
    handleCopy = _ref.handleCopy,
    copied = _ref.copied,
    incrementToken = _ref.incrementToken,
    minQtyToken = _ref.minQtyToken,
    maxQtyToken = _ref.maxQtyToken,
    availableQtyToken = _ref.availableQtyToken,
    qtyToken = _ref.qtyToken,
    tableHeadings = _ref.tableHeadings;
  var isShowUploadAndDownloadButtons = tableData.length === 0 && errorList.length >= 0;
  var tableThemeProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, themeProps.subtitle), themeProps.orderTableHeader), themeProps.errorText), themeProps.orderTableColumnName), themeProps.orderTableContent), themeProps.errorSummaryTitle), themeProps.lineItemError);
  return /*#__PURE__*/React.createElement(BlockLayout, {
    horizontalAlign: "start",
    padding: '12px',
    gap: "12px",
    textAlign: "start",
    textSize: "".concat(themeProps.subtitle.subtitleFontSize, "px"),
    fontFamily: themeProps.subtitle.subtitleFontFamily
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(themeProps.subtitle.subtitleFontSize, "px"),
    alignment: "start",
    color: themeProps.subtitle.subtitleTextColor,
    fontWeight: themeProps.subtitle.subtitleFontWeight,
    fontFamily: themeProps.subtitle.subtitleFontFamily,
    width: '100%'
  }, themeProps.subtitle.subtitleText), tableData.length > 0 && (/*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start"
  }, /*#__PURE__*/React.createElement(Badge, {
    kind: "plain",
    icon: /*#__PURE__*/React.createElement("img", {
      src: img$4,
      alt: "note"
    }),
    fontFamily: themeProps.fileName.fileNameFontFamily,
    textSize: "".concat(themeProps.fileName.fileNameFontSize, "px"),
    color: themeProps.fileName.fileNameTextColor
  }, fileName), /*#__PURE__*/React.createElement(Button, {
    onClick: onDeleteFile,
    kind: "plain",
    padding: "6px"
  }, /*#__PURE__*/React.createElement("img", {
    src: img$c,
    alt: "delete"
  })))), /*#__PURE__*/React.createElement(Divider, null), isShowProgressBar && progressValue !== 100 && (/*#__PURE__*/React.createElement(ProgressBar, {
    title: processingText,
    titleTextSize: "12px",
    titleFontFamily: "inherit",
    titleColor: "#000000",
    helperText: fileName,
    helperTextSize: "12px",
    helperFontFamily: "inherit",
    helperTextColor: "#707070",
    progress: progressValue
  })), errorList.length > 0 && (/*#__PURE__*/React.createElement(AlertBanner, {
    title: tableThemeProps.errorTitleText,
    messages: errorList,
    variant: "critical",
    titleFontFamily: themeProps.errorSummaryTitle.errorSummaryTitleFontFamily,
    titleFontSize: themeProps.errorSummaryTitle.errorSummaryTitleFontSize,
    titleColor: themeProps.errorSummaryTitle.errorCardTitleTextColor,
    bgColor: themeProps.errorSummaryTitle.errorSummaryBackgroundColor,
    contentFontFamily: themeProps.errorSummaryContent.errorSummaryContentFontFamily,
    contentFontSize: themeProps.errorSummaryContent.errorSummaryContentFontSize,
    contentColor: themeProps.errorSummaryContent.errorCardContentTextColor
  })), isShowUploadAndDownloadButtons && !isShowProgressBar && (/*#__PURE__*/React.createElement(BlockLayout, {
    horizontalAlign: "start",
    gap: '12px'
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: isShowWatchTutorial ? "between" : 'end',
    horizontalGap: "4px",
    wrap: false
  }, isShowWatchTutorial && /*#__PURE__*/React.createElement(WatchTutorialBtn, {
    watchTutorialLink: watchTutorialLink,
    tableThemeProps: tableThemeProps
  }), /*#__PURE__*/React.createElement(InlineLayout, {
    width: 'auto',
    horizontalAlign: 'end',
    gap: '10px'
  }, /*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    padding: "0",
    fontFamily: themeProps.uploadCSVButton.uploadCSVButtonFontFamily,
    textSize: "".concat(themeProps.uploadCSVButton.uploadButtonFontSize, "px"),
    color: themeProps.uploadCSVButton.uploadCSVButtonTextColor,
    bgColor: themeProps.uploadCSVButton.uploadCSVButtonBackgroundColor
  }, /*#__PURE__*/React.createElement(FileUpload, {
    content: themeProps.uploadCSVButton.uploadButtonText,
    handleFileUpload: handleFileUpload,
    isAdmin: isAdmin
  })), !isHideDownloadButton && (/*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    onClick: function onClick() {
      return onDownloadButtonClick(true);
    },
    textSize: "".concat(themeProps.downloadCatalogButton.downloadButtonFontSize, "px"),
    fontFamily: themeProps.downloadCatalogButton.downloadCatalogButtonFontFamily,
    color: themeProps.downloadCatalogButton.downloadCatalogButtonTextColor
  }, downloadBtnLoading ? /*#__PURE__*/React.createElement(Spinner, null) : downloadButtonText)))), fileUploadError && /*#__PURE__*/React.createElement("p", null, fileUploadError))), tableData.length > 0 && (/*#__PURE__*/React.createElement(BlockLayout, {
    height: isAdmin ? 'auto' : '100%',
    gap: "10px"
  }, /*#__PURE__*/React.createElement(CollapsibleCard, {
    children: /*#__PURE__*/React.createElement(OrderTableSection, {
      tableData: tableData,
      themeProps: themeProps,
      tableThemeProps: tableThemeProps,
      onTableRowQuantityChange: onTableRowQuantityChange,
      onTableRowDelete: onTableRowDelete,
      isShowAvailableStock: isShowAvailableStock,
      isShowBarcode: isShowBarcode,
      createOrderUrl: createOrderUrl,
      showOrderURL: showOrderURL,
      isShowOrderTable: isShowOrderTable,
      handleCopy: handleCopy,
      copied: copied,
      incrementToken: incrementToken,
      minQtyToken: minQtyToken,
      maxQtyToken: maxQtyToken,
      availableQtyToken: availableQtyToken,
      qtyToken: qtyToken,
      tableHeadings: tableHeadings
    }),
    titleTextSize: themeProps.orderTableHeader.orderTableHeaderFontSize,
    titleFontWeight: 500,
    titleColor: themeProps.orderTableHeader.orderTableHeaderTextColor,
    titleFontFamily: themeProps.orderTableHeader.orderTableHeaderFontFamily,
    titleText: themeProps.orderTableHeader.orderSummaryTableTitleText,
    buttonTextSize: '14px',
    buttonPadding: '0px',
    buttonTextColor: themeProps.orderTableHeader.orderTableHeaderTextColor,
    iconBeforeSize: 12,
    iconSpacing: 4,
    showText: themeProps.orderTableHeader.orderSummaryTableShowSummaryText,
    hideText: themeProps.orderTableHeader.orderSummaryTableHideSummaryText,
    isContentVisible: isShowOrderTable,
    toggleContentVisibility: function toggleContentVisibility() {
      return setIsShowOrderTable(!isShowOrderTable);
    }
  }), /*#__PURE__*/React.createElement(InlineLayout, {
    height: 'auto',
    horizontalAlign: isShowWatchTutorial ? "between" : "end",
    wrap: false
  }, isShowWatchTutorial && /*#__PURE__*/React.createElement(WatchTutorialBtn, {
    watchTutorialLink: watchTutorialLink,
    tableThemeProps: tableThemeProps
  }), /*#__PURE__*/React.createElement(Button, {
    loading: createOrderLoading,
    spinnerColor: themeProps.createOrderButton.createOrderButtonTextColor,
    disabled: !isShowCreateOrderBtn,
    onClick: onCreateOrderClick,
    kind: "secondary",
    fontFamily: themeProps.createOrderButton.createOrderButtonFontFamily,
    textSize: "".concat(themeProps.createOrderButton.createOrderButtonFontSize, "px"),
    bgColor: themeProps.createOrderButton.createOrderButtonBackgroundColor,
    color: themeProps.createOrderButton.createOrderButtonTextColor
  }, themeProps.createOrderButton.createOrderText)))));
};
var OrderTableSection = function OrderTableSection(_ref2) {
  var tableData = _ref2.tableData,
    themeProps = _ref2.themeProps,
    tableThemeProps = _ref2.tableThemeProps,
    onTableRowQuantityChange = _ref2.onTableRowQuantityChange,
    onTableRowDelete = _ref2.onTableRowDelete,
    isShowAvailableStock = _ref2.isShowAvailableStock,
    isShowBarcode = _ref2.isShowBarcode,
    createOrderUrl = _ref2.createOrderUrl,
    showOrderURL = _ref2.showOrderURL,
    isShowOrderTable = _ref2.isShowOrderTable,
    handleCopy = _ref2.handleCopy,
    copied = _ref2.copied,
    incrementToken = _ref2.incrementToken,
    minQtyToken = _ref2.minQtyToken,
    maxQtyToken = _ref2.maxQtyToken,
    availableQtyToken = _ref2.availableQtyToken,
    qtyToken = _ref2.qtyToken,
    tableHeadings = _ref2.tableHeadings;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowOrderTable && (/*#__PURE__*/React.createElement(Table, {
    tableData: cloneDeep(tableData),
    headingFontSize: themeProps.orderTableColumnName.orderTableColumnNameFontSize,
    contentFontSize: themeProps.orderTableContent.orderTableContentFontSize,
    headingColor: themeProps.orderTableColumnName.orderTableColumnNameTextColor,
    contentColor: themeProps.orderTableContent.orderTableContentTextColor,
    onTableRowQuantityChange: onTableRowQuantityChange,
    onTableRowDelete: onTableRowDelete,
    themeProps: tableThemeProps,
    isShowAvailableStock: isShowAvailableStock,
    isShowBarcode: isShowBarcode,
    incrementToken: incrementToken,
    minQtyToken: minQtyToken,
    maxQtyToken: maxQtyToken,
    availableQtyToken: availableQtyToken,
    qtyToken: qtyToken,
    tableHeadings: tableHeadings
  })), showOrderURL && (/*#__PURE__*/React.createElement(CopyLinkBox, {
    text: createOrderUrl,
    handleCopy: handleCopy,
    copied: copied
  })));
};
var WatchTutorialBtn = function WatchTutorialBtn(_ref3) {
  var watchTutorialLink = _ref3.watchTutorialLink,
    tableThemeProps = _ref3.tableThemeProps;
  return /*#__PURE__*/React.createElement(InlineLayout, {
    width: 'auto',
    wrap: false,
    horizontalAlign: "start",
    gap: '10px'
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      color: tableThemeProps.watchTutorialTextColor,
      width: '-webkit-fill-available',
      fontSize: tableThemeProps.watchTutorialFontSize,
      fontFamily: tableThemeProps.watchTutorialFontFamily
    },
    href: watchTutorialLink,
    target: "_blank"
  }, tableThemeProps.watchTutorialText));
};

var CSVUploadIcon = function CSVUploadIcon(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      color: color,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9277 2.96898L10.0312 0.0724306C10.0096 0.0492402 9.98348 0.030817 9.95438 0.0183457C9.92528 0.00587439 9.89389 -0.000369067 9.86224 1.68599e-05H2.82845C2.58173 0.00128535 2.34548 0.0998561 2.17103 0.274314C1.99657 0.448772 1.898 0.685023 1.89673 0.93174V5.55173C1.89673 5.61575 1.92216 5.67715 1.96743 5.72242C2.01269 5.76768 2.07409 5.79311 2.13811 5.79311C2.20213 5.79311 2.26352 5.76768 2.30879 5.72242C2.35406 5.67715 2.37949 5.61575 2.37949 5.55173V0.93174C2.37949 0.812667 2.42679 0.698471 2.51099 0.614274C2.59518 0.530076 2.70938 0.482775 2.82845 0.482775H9.62086V3.13794C9.62086 3.20196 9.64629 3.26336 9.69156 3.30862C9.73682 3.35389 9.79822 3.37932 9.86224 3.37932H12.5174V13.0683C12.5174 13.1873 12.4701 13.3015 12.3859 13.3857C12.3017 13.4699 12.1875 13.5172 12.0684 13.5172H2.82845C2.70938 13.5172 2.59518 13.4699 2.51099 13.3857C2.42679 13.3015 2.37949 13.1873 2.37949 13.0683V11.8276C2.37949 11.7636 2.35406 11.7022 2.30879 11.6569C2.26352 11.6116 2.20213 11.5862 2.13811 11.5862C2.07409 11.5862 2.01269 11.6116 1.96743 11.6569C1.92216 11.7022 1.89673 11.7636 1.89673 11.8276V13.0683C1.898 13.315 1.99657 13.5512 2.17103 13.7257C2.34548 13.9002 2.58173 13.9987 2.82845 14H12.0684C12.3152 13.9987 12.5514 13.9002 12.7259 13.7257C12.9003 13.5512 12.9989 13.315 13.0002 13.0683V3.13794C13.0005 3.10629 12.9943 3.0749 12.9818 3.0458C12.9694 3.0167 12.9509 2.99053 12.9277 2.96898ZM10.1036 0.825533L12.1746 2.89656H10.1036V0.825533Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0691 10.3229V7.05943C11.0697 6.95655 11.0499 6.85456 11.0109 6.75939C10.9718 6.66421 10.9142 6.57774 10.8415 6.50499C10.7687 6.43224 10.6822 6.37466 10.5871 6.33558C10.4919 6.29651 10.3899 6.27672 10.287 6.27736H1.71324C1.61035 6.27672 1.50837 6.29651 1.41319 6.33558C1.31802 6.37466 1.23155 6.43224 1.1588 6.50499C1.08605 6.57774 1.02847 6.66421 0.989393 6.75939C0.950318 6.85456 0.930526 6.95655 0.931167 7.05943V10.3229C0.930526 10.4258 0.950318 10.5277 0.989393 10.6229C1.02847 10.7181 1.08605 10.8046 1.1588 10.8773C1.23155 10.9501 1.31802 11.0076 1.41319 11.0467C1.50837 11.0858 1.61035 11.1056 1.71324 11.1049H10.287C10.3899 11.1056 10.4919 11.0858 10.5871 11.0467C10.6822 11.0076 10.7687 10.9501 10.8415 10.8773C10.9142 10.8046 10.9718 10.7181 11.0109 10.6229C11.0499 10.5277 11.0697 10.4258 11.0691 10.3229ZM3.10358 9.32356C3.1821 9.40552 3.27659 9.47051 3.38121 9.51451C3.48583 9.55852 3.59836 9.58061 3.71185 9.57942C3.83459 9.57956 3.9561 9.55493 4.0691 9.50701C4.19033 9.446 4.30113 9.36616 4.39737 9.27046L4.67254 9.55046C4.55368 9.69036 4.40568 9.80259 4.2389 9.87931C4.07213 9.95602 3.8906 9.99537 3.70703 9.9946C3.52952 10.003 3.35218 9.9748 3.18607 9.91168C3.01995 9.84855 2.86862 9.75188 2.74151 9.6277C2.49909 9.37813 2.36349 9.0439 2.36349 8.69598C2.36349 8.34805 2.49909 8.01382 2.74151 7.76425C2.86897 7.63995 3.02014 7.54256 3.18601 7.47787C3.35188 7.41318 3.52906 7.38252 3.70703 7.3877C3.8899 7.38541 4.07106 7.42311 4.23784 7.49816C4.40462 7.57321 4.55298 7.6838 4.67254 7.82218L4.4022 8.11667C4.30621 8.01513 4.19145 7.93316 4.06427 7.87529C3.94502 7.82612 3.81662 7.80307 3.68772 7.8077C3.46955 7.81603 3.26188 7.90355 3.10358 8.05391C3.01783 8.13383 2.95019 8.2312 2.90522 8.33945C2.86026 8.44771 2.839 8.56434 2.84289 8.68149C2.83997 8.80067 2.86161 8.91918 2.90646 9.02964C2.95131 9.1401 3.01841 9.24015 3.10358 9.32356ZM6.69047 9.80632C6.50395 9.94867 6.27311 10.0205 6.03875 10.0091C5.65086 10.0111 5.27659 9.86623 4.99116 9.60356L5.25668 9.28011C5.47056 9.48486 5.75248 9.60348 6.0484 9.61322C6.16425 9.61958 6.27915 9.58917 6.37668 9.52632C6.41512 9.50028 6.44635 9.46493 6.46745 9.42357C6.48855 9.38221 6.49884 9.33618 6.49737 9.28977C6.49908 9.2452 6.48933 9.20093 6.46904 9.1612C6.44876 9.12148 6.41862 9.08762 6.38151 9.06287C6.26113 8.99105 6.12859 8.94196 5.99047 8.91805C5.84829 8.88389 5.70808 8.84199 5.57047 8.79253C5.47729 8.75976 5.39066 8.71073 5.31461 8.6477C5.23845 8.58609 5.17843 8.50687 5.13974 8.41687C5.10105 8.32687 5.08485 8.22881 5.09254 8.13115C5.08638 8.02679 5.10659 7.92257 5.15131 7.82807C5.19602 7.73358 5.2638 7.65187 5.3484 7.59046C5.53115 7.4603 5.75177 7.39411 5.97599 7.40219C6.14005 7.40138 6.30313 7.42748 6.45875 7.47943C6.60861 7.5285 6.74784 7.60549 6.86909 7.70632L6.6422 8.02494C6.55362 7.94926 6.44994 7.89331 6.33806 7.86081C6.2172 7.81739 6.08992 7.79455 5.96151 7.79322C5.85504 7.79123 5.74999 7.81791 5.65737 7.87046C5.61957 7.8945 5.58889 7.92822 5.56852 7.96812C5.54814 8.00802 5.53882 8.05264 5.54151 8.09736C5.53905 8.14339 5.5484 8.18929 5.56868 8.2307C5.58896 8.2721 5.61949 8.30763 5.65737 8.33391C5.81744 8.41512 5.98804 8.47361 6.16427 8.5077C6.37643 8.54852 6.57633 8.63773 6.7484 8.76839C6.81384 8.83015 6.86534 8.90516 6.89947 8.98841C6.93361 9.07166 6.94958 9.16123 6.94633 9.25115C6.94747 9.35526 6.92453 9.45823 6.87931 9.55202C6.83409 9.64581 6.76781 9.72788 6.68564 9.79184L6.69047 9.80632ZM8.6215 9.98011H8.13875L7.12978 7.46494H7.61254L8.38978 9.34287L9.16219 7.46494H9.64495L8.6215 9.98011Z",
    fill: "currentColor"
  })));
};

var updateWindowUpro = function updateWindowUpro(config) {
  if (window.upro) {
    /* If upro already exists, append the keys/values from the config object */
    Object.assign(window.upro, config);
  } else {
    /* If upro doesn't exist, initialize it with the config values */
    window.upro = Object.assign(Object.assign({}, config), {
      name: 'upro'
    });
  }
};

function CSVUpload(_ref) {
  var _this = this;
  var themeProps = _ref.themeProps,
    isShowWatchTutorial = _ref.isShowWatchTutorial,
    watchTutorialLink = _ref.watchTutorialLink,
    locationOptions = _ref.locationOptions,
    selectedLocation = _ref.selectedLocation,
    setSelectedLocation = _ref.setSelectedLocation,
    onDownloadButtonClick = _ref.onDownloadButtonClick,
    downloadBtnLoading = _ref.downloadBtnLoading,
    downloadButtonText = _ref.downloadButtonText,
    progressValue = _ref.progressValue,
    tableData = _ref.tableData,
    onTableRowQuantityChange = _ref.onTableRowQuantityChange,
    onTableRowDelete = _ref.onTableRowDelete,
    onDeleteFile = _ref.onDeleteFile,
    fileName = _ref.fileName,
    isShowOrderTable = _ref.isShowOrderTable,
    createOrderButtonText = _ref.createOrderButtonText,
    showOrderURL = _ref.showOrderURL,
    createOrderUrl = _ref.createOrderUrl,
    errorList = _ref.errorList,
    isHideDownloadButton = _ref.isHideDownloadButton,
    createOrderLoading = _ref.createOrderLoading,
    onCreateOrderClick = _ref.onCreateOrderClick,
    isShowCreateOrderBtn = _ref.isShowCreateOrderBtn,
    handleFileUpload = _ref.handleFileUpload,
    fileUploadError = _ref.fileUploadError,
    isShowProgressBar = _ref.isShowProgressBar,
    isAdmin = _ref.isAdmin,
    setIsShowOrderTable = _ref.setIsShowOrderTable,
    _ref$isShowBackBtn = _ref.isShowBackBtn,
    isShowBackBtn = _ref$isShowBackBtn === void 0 ? true : _ref$isShowBackBtn,
    _ref$isShowLocationOp = _ref.isShowLocationOptions,
    isShowLocationOptions = _ref$isShowLocationOp === void 0 ? true : _ref$isShowLocationOp,
    isShowAvailableStock = _ref.isShowAvailableStock,
    isShowBarcode = _ref.isShowBarcode,
    incrementToken = _ref.incrementToken,
    minQtyToken = _ref.minQtyToken,
    maxQtyToken = _ref.maxQtyToken,
    availableQtyToken = _ref.availableQtyToken,
    qtyToken = _ref.qtyToken,
    tableHeadings = _ref.tableHeadings,
    isShowModal = _ref.isShowModal;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    copied = _useState4[0],
    setCopied = _useState4[1];
  var open = function open() {
    return !isAdmin && setModal(true);
  };
  var close = function close() {
    return !isAdmin && setModal(false);
  };
  var isMobile = window.innerWidth < 768;
  var _useState5 = useState(isShowModal),
    _useState6 = _slicedToArray(_useState5, 2),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  updateWindowUpro({
    openCsvUploadModal: open,
    initiateCatalogDownload: onDownloadButtonClick
  });
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    stage = _useState8[0],
    setStage = _useState8[1];
  useEffect(function () {
    if (locationOptions.length <= 1) {
      setStage(1);
    } else {
      setStage(0);
    }
    !isShowLocationOptions && setStage(1);
  }, [locationOptions, isShowLocationOptions]);
  useEffect(function () {
    if (isShowModal) {
      setStage(1);
      setModal(true);
    } else {
      setStage(0);
      setModal(false);
    }
  }, [isShowModal]);
  useEffect(function () {
    if (modal) {
      setShowModal(true);
    }
  }, [modal]);
  var isTriggerVisible = isAdmin && !isShowModal || !isAdmin;
  var goNext = function goNext() {
    if (!isShowLocationOptions && stage === content.length - 1) {
      setStage(1);
      return;
    }
    if (stage === 3) {
      setStage(0);
      close();
    } else {
      setStage(stage + 1);
    }
  };
  var goBack = function goBack() {
    if (!isShowLocationOptions && stage === 1) {
      setStage(1);
      return;
    }
    if (stage === 0) {
      close();
    } else {
      setStage(stage - 1);
    }
  };
  var handleCopy = function handleCopy() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return navigator.clipboard.writeText(createOrderUrl);
          case 3:
            setCopied(true);
            setTimeout(function () {
              return setCopied(false);
            }, 1500);
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error('Failed to copy text:', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
  var hideLocationOptions = locationOptions.length === 0;
  var content = [/*#__PURE__*/React.createElement(LocationSelect, {
    next: goNext,
    locations: locationOptions,
    themeProps: themeProps,
    selectedLocation: selectedLocation,
    setSelectedLocation: setSelectedLocation
  }), /*#__PURE__*/React.createElement(UploadModal, {
    themeProps: themeProps,
    watchTutorialLink: watchTutorialLink,
    isShowWatchTutorial: isShowWatchTutorial,
    handleFileUpload: handleFileUpload,
    isHideDownloadButton: isHideDownloadButton,
    downloadBtnLoading: downloadBtnLoading,
    onDownloadButtonClick: onDownloadButtonClick,
    isShowProgressBar: isShowProgressBar,
    progressValue: progressValue,
    processingText: themeProps.otherText.processingText,
    fileName: fileName,
    tableData: tableData,
    isShowOrderTable: isShowOrderTable,
    onDeleteFile: onDeleteFile,
    errorList: errorList,
    onTableRowQuantityChange: onTableRowQuantityChange,
    createOrderLoading: createOrderLoading,
    isShowCreateOrderBtn: isShowCreateOrderBtn,
    createOrderUrl: createOrderUrl,
    showOrderURL: showOrderURL,
    onCreateOrderClick: onCreateOrderClick,
    fileUploadError: fileUploadError,
    downloadButtonText: downloadButtonText,
    onTableRowDelete: onTableRowDelete,
    isAdmin: isAdmin,
    setIsShowOrderTable: setIsShowOrderTable,
    createOrderButtonText: createOrderButtonText,
    isShowAvailableStock: isShowAvailableStock,
    isShowBarcode: isShowBarcode,
    handleCopy: handleCopy,
    copied: copied,
    incrementToken: incrementToken,
    minQtyToken: minQtyToken,
    maxQtyToken: maxQtyToken,
    availableQtyToken: availableQtyToken,
    qtyToken: qtyToken,
    tableHeadings: tableHeadings
  })];
  return /*#__PURE__*/React.createElement(React.Fragment, null, isTriggerVisible && /*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    onClick: open,
    iconBefore: /*#__PURE__*/React.createElement(CSVUploadIcon, {
      color: themeProps.triggerButton.triggerButtonTextColor
    }),
    bgColor: themeProps.triggerButton.triggerButtonBackgroundColor,
    iconSpacing: isMobile ? 0 : 6,
    textSize: "".concat(themeProps.triggerButton.triggerButtonFontSize, "px"),
    color: themeProps.triggerButton.triggerButtonTextColor,
    padding: isMobile ? '0' : '9px',
    whitespace: "nowrap",
    borderColor: isMobile ? 'transparent' : themeProps.triggerButton.triggerButtonTextColor
  }, !isMobile && themeProps.triggerButton.triggerButtonText), showModal && modal && (/*#__PURE__*/React.createElement(ModalContainer, {
    goBack: goBack,
    isOpen: modal,
    exit: close,
    isAdmin: isAdmin,
    stage: stage,
    titleStyles: themeProps.title,
    locationStyles: themeProps.location,
    hideBackButton: locationOptions.length <= 1,
    isShowBackBtn: isShowBackBtn,
    selectedLocationDisplayName: (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.name) || '',
    hideLocationOptions: hideLocationOptions
  }, content[stage])));
}

var CreditLimit = function CreditLimit(_ref) {
  var bannerType = _ref.bannerType,
    titleText = _ref.titleText,
    bodyText = _ref.bodyText,
    availableCreditLimitText = _ref.availableCreditLimitText,
    totalCreditLimitText = _ref.totalCreditLimitText;
  var creditStatus = [(availableCreditLimitText === null || availableCreditLimitText === void 0 ? void 0 : availableCreditLimitText.trim()) ? "\n".concat(availableCreditLimitText.trim()) : (totalCreditLimitText === null || totalCreditLimitText === void 0 ? void 0 : totalCreditLimitText.trim()) ? "\n".concat(totalCreditLimitText.trim()) : null, (availableCreditLimitText === null || availableCreditLimitText === void 0 ? void 0 : availableCreditLimitText.trim()) ? totalCreditLimitText === null || totalCreditLimitText === void 0 ? void 0 : totalCreditLimitText.trim() : null].filter(Boolean);
  var bannerContent = [bodyText].concat(_toConsumableArray(creditStatus)).filter(function (content) {
    return content !== null;
  });
  return /*#__PURE__*/React.createElement(AlertBanner, {
    variant: bannerType,
    title: titleText,
    messages: bannerContent,
    titleFontSize: "14",
    contentBullets: false,
    contentFontSize: "13"
  });
};

var _templateObject;
var Dialog = styled.dialog(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  z-index: 555;\n  width: 90%;\n  max-width: 700px;\n  border: none;\n  border-radius: 5px;\n  outline: none;\n  padding: 21px;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: space-between;\n  gap: 14px;\n  font-family: inherit, sans-serif;\n\n  & .mrca-heading {\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  & .mrca-message {\n    font-size: 14px;\n  }\n\n  box-shadow:\n    0 32px 32px 0 #00000014,\n    0 12px 12px 0 #0000000e,\n    0 6px 6px 0 #0000000b,\n    0 3px 3px 0 #00000009,\n    0 1px 1px 0 #00000007,\n    0 -2px 4px 0 #00000014;\n"])));
var Toast = function Toast(_ref) {
  var showToast = _ref.showToast,
    heading = _ref.heading,
    message = _ref.message;
  var toastRef = useRef(null);
  useEffect(function () {
    var _a, _b;
    showToast ? (_a = toastRef.current) === null || _a === void 0 ? void 0 : _a.show() : (_b = toastRef.current) === null || _b === void 0 ? void 0 : _b.close();
  }, [showToast]);
  return /*#__PURE__*/React.createElement(Dialog, {
    ref: toastRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "mrca-heading"
  }, heading), /*#__PURE__*/React.createElement(InlineLayout, {
    gap: "14px",
    wrap: false,
    horizontalAlign: 'start'
  }, /*#__PURE__*/React.createElement(Spinner, {
    color: "#197CBD"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mrca-message"
  }, message)));
};

export { CSVUpload, CreditLimit, Toast };
